<template>
	<v-app>
		<v-navigation-drawer v-if="drawer" v-model="drawer" hide-overlay absolute temporary right dark color="rgba(0, 0, 0, 0.8)">
			<v-list dense dark v-if="(experience.menuDataList && experience.menuDataList.length > 0) || myDocument">
				<div v-for="(menu, idxMenu) in experience.menuDataList" :key="idxMenu">
					<v-list-group v-if="menu.childList && menu.childList.length > 0" color="white" v-model="menu.toggleOpen">
						<template v-slot:activator>
							<v-list-item-content>
								<v-list-item-title>{{ menu.name }}</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-hover v-for="(subMenu, idxSubMenu) in menu.childList" :key="idxSubMenu" v-slot:default="{ hover }">
							<v-list-group v-if="subMenu.childList && subMenu.childList.length > 0" class="pl-0" sub-group color="white" v-model="subMenu.toggleOpen">
								<template v-slot:activator>
									<v-list-item-content>
										<v-list-item-title v-if="hover" style="color: #eb6e1f">{{ subMenu.name }}</v-list-item-title>
										<v-list-item-title v-else>{{ subMenu.name }}</v-list-item-title>
									</v-list-item-content>
								</template>
								<v-hover v-for="(item, idxItem) in subMenu.childList" :key="idxItem" v-slot:default="{ hover }">
									<v-list-item @click="navigateTo(item)" link>
										<v-list-item-icon class="mr-2">
											<v-img v-if="hover" contain aspect-ratio="1" :src="$root.asset(item.iconHover)"></v-img>
											<v-img v-else contain aspect-ratio="1" :src="$root.asset(item.icon)"></v-img>
										</v-list-item-icon>

										<v-list-item-content>
											<v-list-item-title v-if="hover" style="color: #eb6e1f">{{ item.name }}</v-list-item-title>
											<v-list-item-title v-else>{{ item.name }}</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</v-hover>
							</v-list-group>
							<v-list-item v-else @click="navigateTo(subMenu)" link>
								<v-list-item-icon class="mr-2">
									<v-img v-if="hover" contain aspect-ratio="1" :src="$root.asset(subMenu.iconHover)"></v-img>
									<v-img v-else contain aspect-ratio="1" :src="$root.asset(subMenu.icon)"></v-img>
								</v-list-item-icon>

								<v-list-item-content>
									<v-list-item-title v-if="hover" style="color: #eb6e1f">{{ subMenu.name }}</v-list-item-title>
									<v-list-item-title v-else>{{ subMenu.name }}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-hover>
					</v-list-group>
					<v-list-item v-else @click="navigateTo(menu)" link>
						<v-list-item-icon v-if="menu.icon">
							<v-icon>{{ menu.icon }}</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title>{{ menu.name }}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</div>
				<v-list-item v-if="$router.currentRoute.path.includes('/room/')" >
					<v-list-item-title>
						Fit to screen
					</v-list-item-title>
					<v-switch v-model="$store.state.isFitToWidth" style="margin-top: 0px; align-items: center; color: white;" color="#eb6e1f" dense hide-details dark @change="setFitToScreen"></v-switch>
				</v-list-item>
				<v-list-item v-if="$router.currentRoute.path.includes('/room/')" >
					<v-list-item-title>
						Video Transition
					</v-list-item-title>
					<v-switch v-model="$store.state.showVideoTransition" style="margin-top: 0px; align-items: center; color: white;" color="#eb6e1f" dense hide-details dark  @change="setShowVideoTransition"></v-switch>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>
		<v-main>
			<!-- BURGER MENU  -->
			<!-- <v-tooltip bottom v-if="(experience.menuDataList && experience.menuDataList.length > 0)">
				<template v-slot:activator="{ on, attrs }">
					<v-btn v-bind="attrs" v-on="on" @click="drawer = !drawer" class="ma-1" 
					style="right: 0px; z-index: 6;" dark right icon fixed outlined elevation="4"><v-icon 
					dark large>mdi-microsoft-xbox-controller-menu</v-icon></v-btn>
				</template>
				<span>Menu</span>
			</v-tooltip> -->

			<!-- MENU BUTTON  -->
			<v-tooltip bottom v-if="(experience.menuDataList && experience.menuDataList.length > 0)">
				<template v-slot:activator="{ on, attrs }">
					<v-btn v-bind="attrs" v-on="on" @click="drawer = !drawer" 
					class="ma-1 pa-1" 
					style="right: 0px; 
					font-size: calc(10px + 0.2vw);
					min-width: 4.5em;
					height: 2.7em;
					z-index: 6; 
					background-color: #757575;" 
					dark 
					right 
					fixed 
					outlined 
					elevation="4"
					>MENU</v-btn>
				</template>
				<span>Menu</span>
			</v-tooltip>


			<div id="custom">
				<v-btn
					:class="isShow ? '' : 'd-none'"
					style="background: #00000033; color: white; border: 2px solid; position:fixed; z-index: 100;"
					:style="{
						left: btnSkipLeft,
						bottom: '10px'
					}"
					@click="stopVideoTransition(!tmpSlug ? entity.introTransition : entity.outroTransition )"
				> SKIP</v-btn>
				<v-btn
					v-if="isShow && showBtnTransition"
					height="70px"
					class="rounded-circle"
					style="background: #00000033; color: white; border: 2px solid; position:fixed; z-index: 100;"
					:style="{
						left: 'calc(50vw - 25px)',
						bottom: '50vh'
					}"
					@click="playVideoTransition(!tmpSlug ? entity.introTransition : entity.outroTransition )"
				>
					<v-icon id="box-button-icon" large>mdi-play</v-icon>
				</v-btn>
				<div id="room-view" class="v-card v-card__text" style="padding: 0px; transform-origin: top left; position: absolute; z-index: 1;" ref="roomView">
					<VueIdentifyNetwork @network-speed="handleNetworkSpeed" >
						<video
							:slot="loadType"
							:class="isShow && ((!tmpSlug && $root.isVideo(entity.introTransition) || (tmpSlug && $root.isVideo(entity.outroTransition))) && $store.state.showVideoTransition) ? '' : 'd-none'"
							id="videoTransition"
							style="display: block"
							width="960px"
							preload="auto"
							muted
							playsinline
							disablepictureinpicture
							type="video/mp4"
							ref="backgroundTransition"
						>
						</video>

					</VueIdentifyNetwork>
					<img
						v-if="((!tmpSlug && !$root.isVideo(entity.introTransition)) || (tmpSlug && !$root.isVideo(entity.outroTransition))) && isShow && showBtnTransition"
						:src="transitionThumbnail"
						style="position:fixed; z-index: 99;"
						width="960px"
						@load="calcScale()"
					/>
					<div v-if="($root.isYoutubeUrl(entity.introTransition) || (tmpSlug && $root.isYoutubeUrl(entity.outroTransition))) && $store.state.showVideoTransition  && isShow">
						<youtube
							id="videoTransition"
							:videoId="videoTransition"
							:player-vars="transitionYoutubeParams"
							style="pointer-events: none "
							width="960"
							height="530"
							ref="backgroundTransition"
							@ready="calcScale()"
							@ended="transitionEnds(true)"
							@playing="setShowBtnTransition(false)"
							@paused="setShowBtnTransition(true)"
						></youtube>
					</div>
					<div
						v-else-if="($root.isVimeoUrl(entity.introTransition) ||  (tmpSlug && $root.isVimeoUrl(entity.outroTransition))) && $store.state.showVideoTransition"
						ref="backgroundTransition"
					>
						<vimeo-player
							:class="isShow ? '' : 'd-none'"
							:video-url="videoTransition"
							:options="transitionVimeoParams"
							player-width="960"
							player-height="auto"
							style="pointer-events: none "
							@loaded="calcScale()"
							@ended="transitionEnds(false)"
							@playing="setShowBtnTransition(false)"
							@pause="setShowBtnTransition(true)"
							ref="backgroundTransitionVimeo"
						>
						</vimeo-player>
					</div>
					<img
						v-if="$root.isImage(entity.background)"
						:class="isShow ? 'd-none' : ''"
						:src="$root.asset(entity.background)"
						style="display: block"
						width="960px"
						ref="background"
						@load="calcScale()"
					/>
					<video
						v-else-if="$root.isVideo(entity.background)"
						:class="isShow ? 'd-none' : ''"
						id="video"
						style="display: block"
						width="960px"
						preload="auto"
						autoplay="autoplay"
						muted
						playsinline
						disablepictureinpicture
						loop="loop"
						:src="$root.asset(entity.background)"
						type="video/mp4"
						ref="background"
						@load="calcScale()"
					>
					</video>
					<div v-else-if="$root.isYoutubeUrl(entity.background)">
					<template v-if="!isShow">
						<youtube
							:class="isShow ? 'd-none' : ''"
							:videoId="$root.getYoutubeId(entity.background, backgroundYoutubeParams)"
							:player-vars="backgroundYoutubeParams"
							style="pointer-events: none "
							width="960"
							height="530"
							ref="background"
							@ready="calcScale()"
						></youtube>
					</template>
				</div>
				<div v-else-if="$root.isVimeoUrl(entity.background)" ref="background">
					<template v-if="!isShow">
						<vimeo-player
							:video-url="entity.background"
							:options="backgroundVimeoParams"
							style="pointer-events: none "
							player-width="960"
							player-height="auto"
							@loaded="calcScale()"
						></vimeo-player>
					</template>
				</div>
					<div
						v-for="(item, index) in entity.linkToDataList"
						:key="index"
					>
						<v-tooltip v-if="item.tooltip && item.tooltip.show" :color="item.tooltip.backgroundColor + ' !important'" top>
							<template v-slot:activator="{ on, attrs }">
								<img
									v-if="item.type === 'Image'"
									:src="$root.asset(item.value)"
									:class="isShow ? 'd-none' : ''"
									:style="{
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 1,
										width: item.width + 'px',
										height: item.height + 'px',
										objectFit: $root.setBackgroundSize(item.subType),
										objectPosition: $root.setBackgroundPosition(item),
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform:
											'skew(' +
											item.skewX +
											'deg,' +
											item.skewY +
											'deg)',
										position: 'absolute'
									}"
									v-on="on"
									v-bind="attrs"
								/>
								<iframe
									v-else-if="item.type === 'Video' && !isShow"
									:class="isShow ? 'd-none' : ''"
									:style="{
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 1,
										width: item.width + 'px',
										height: item.height + 'px',
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform:
											'skew(' +
											item.skewX +
											'deg,' +
											item.skewY +
											'deg)',
										position: 'absolute',
									}"
									frameborder="0"
									allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture;"
									scrolling="0"
									:src="$root.asset(item.value)"
									v-on="on"
									v-bind="attrs"
								>
								</iframe>
								<div
									v-else-if="item.type === 'Zoom' && item.target === 'Embed' && isShowZoomEmbed == true"
									:class="isShow ? 'd-none' : ''"
									:style="{
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 999,
										width: item.width + 'px',
										height: item.height + 'px',
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform:
											'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
										position: 'absolute',
									}"
									v-on="on"
									v-bind="attrs"
								>
									<v-card :height="item.height + 'px'" :style="{overflow: item.height < 295 ? 'auto' : 'none'}" :loading="zoomLoading">
										<div v-if="isShowZoomIframe == false">
											<v-form v-model="zoomFormValid" @submit.prevent="joinZoom()">
												<v-row>
													<v-col cols="1" sm="1"></v-col>
													<v-col cols="10" sm="10">
														<v-text-field
															label="Zoom Name"
															v-model="zoomFullName"
															:rules="zoomFullNameRules"
															:counter="100"
															required
															name="Name"
														></v-text-field>
													</v-col>
													<v-col cols="1" sm="1"></v-col>
												</v-row>
												<v-row>
													<v-col cols="1" sm="1"></v-col>
													<v-col cols="10" sm="10">
														<v-text-field
															label="Zoom E-mail"
															v-model="zoomEmail"
															:rules="zoomEmailRules"
															required
															name="Email"
														></v-text-field>
													</v-col>
													<v-col cols="1" sm="1"></v-col>
												</v-row>
												<v-row>
													<v-col cols="1" sm="1"></v-col>
													<v-col cols="10" sm="10" class="text-center">
														<v-btn :disabled="!zoomFormValid" block type="submit" color="primary">
															Next
														</v-btn>
													</v-col>
													<v-col cols="1" sm="1"></v-col>
												</v-row>
											</v-form>
										</div>
										<div id="iframe-container" v-if="isShowZoomIframe == true"
											:style="{
												height: '100%',
												transform: 'scale(0.5)',
												transformOrigin: 'left top'
											}"
										>
											<iframe
												id="iframe"
												:style="{
													zIndex: layerMode == true ? entity.linkToDataList.length - index : 999,
													width: (item.width * 2) + 'px',
													height: (item.height * 2) -36 + 'px',
													transform:
														'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
													position: 'absolute',
													minHeight: '560px',
													marginTop: '20px'
												}"
												frameborder="0"
												allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture; camera; microphone;"
												scrolling="0"
												:src="
													baseLocation +
													'/zoom.jsp?nickname=' +
													zoomFullName +
													'&email=' +
													zoomEmail +
													'&meetingId=' +
													(item.value.includes('pwd=') ? item.value.substring(item.value.indexOf('j/') + 2, item.value.indexOf('?')) : item.value.substring(item.value.indexOf('j/') + 2, item.value.length)) +
													'&role=' +
													0 +
													'&password=' +
													(item.value.includes('pwd=') ? item.value.substring(item.value.indexOf('pwd=') + 4, item.value.length) : 'null') +
													'&disablePreview=' + ((item.disablePreview == null || item.disablePreview === '') ? true : item.disablePreview)
												"
												allowfullscreen
												@load="zoomLoad()"
											></iframe>
										</div>
									</v-card>
								</div>
								<div
									v-else-if="item.type === 'Teams' && item.target === 'Embed'"
									:class="isShow ? 'd-none' : ''"
									:style="{
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 999,
										width: item.width + 'px',
										height: item.height + 'px',
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform:
											'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
										position: 'absolute',
									}"
									v-on="on"
									v-bind="attrs"
								>
									<v-card :height="item.height + 'px'" :style="{overflow: item.height < 295 ? 'auto' : 'none'}" :loading="zoomLoading">
										<div id="iframe-container"
											:style="{
												height: '100%',
												transform: 'scale(0.5)',
												transformOrigin: 'left top'
											}"
										>
											<iframe
												id="iframe"
												:style="{
													zIndex: layerMode == true ? entity.linkToDataList.length - index : 999,
													width: (item.width * 2) + 'px',
													height: (item.height * 2) -36 + 'px',
													transform:
														'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
													position: 'absolute',
													minHeight: '560px',
													marginTop: '20px'
												}"
												frameborder="0"
												allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture; camera; microphone;"
												scrolling="0"
												:src="$root.getUrlTeamsWithLink(item.value)"
												allowfullscreen
												@load="zoomLoad()"
											></iframe>
										</div>
									</v-card>
								</div>
								<div
									v-else-if="item.type === 'Text'"
									class="hotspot_text"
									:class="isShow ? 'd-none' : ''"
									v-html="item.value"
									:style="{
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 2,
										width: item.width + 'px',
										height: item.height + 'px',
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform:
											'skew(' +
											item.skewX +
											'deg,' +
											item.skewY +
											'deg)',
										position: 'absolute',
										backgroundColor: item.backgroundColor,
										borderStyle:
											item.borderWidth === 'none'
												? item.borderWidth
												: 'solid',
										borderWidth: item.borderWidth,
										borderColor: item.borderColor,
										padding:
											(item.padding ? item.padding : '0') +
											'px',
									}"
									v-on="on"
									v-bind="attrs"
								></div>
								<div
									v-else-if="
										item.type === 'Embed_HTML' &&
										item.target === 'Embed'
									"
									:class="isShow ? 'd-none' : ''"
									:style="{
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 1,
										width: item.width + 'px',
										height: item.height + 'px',
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform:
											'skew(' +
											item.skewX +
											'deg,' +
											item.skewY +
											'deg)',
										position: 'absolute',
										overflow: 'hidden',
									}"
									v-append="item.valueRender ? item.valueRender : item.value"
									v-on="on"
									v-bind="attrs"
								></div>
								<v-btn
									v-else-if="item.type === 'Button' && !item.backgroundImage"
									class="hotspot_btn"
									:class="isShow ? ('d-none hotspot_btn_custom_' + item.id) : ('hotspot_btn_custom_' + item.id)"
									absolute
									:color="item.backgroundColor"
									:style="{
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 2,
										width: item.width + 'px',
										height: item.height + 'px',
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
										textTransform: 'none',
										borderStyle: (item.borderWidth === 'none' ? item.borderWidth : 'solid'),
										borderRadius: item.borderRadius,
										borderWidth: item.borderWidth,
										borderColor: item.borderColor,
									}"
									v-on="on"
									v-bind="attrs"
								>
									<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
								</v-btn>
								<v-btn
									v-else-if="item.type === 'Button' && item.backgroundImage"
									class="hotspot_btn"
									:class="isShow ? ('d-none hotspot_btn_custom_' + item.id) : ('hotspot_btn_custom_' + item.id)"
									absolute
									:style="{
										backgroundImage: 'url(' + item.backgroundImage + ')',
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 2,
										width: item.width + 'px',
										height: item.height + 'px',
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
										textTransform: 'none',
										borderStyle: (item.borderWidth === 'none' ? item.borderWidth : 'solid'),
										borderRadius: item.borderRadius,
										borderWidth: item.borderWidth,
										borderColor: item.borderColor,
									}"
									v-on="on"
									v-bind="attrs"
								>
									<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
								</v-btn>
								<v-btn
									v-else-if="item.type === 'Back_Button' && !item.backgroundImage"
									class="hotspot_btn"
									:class="isShow ? ('d-none hotspot_btn_custom_' + item.id) : ('hotspot_btn_custom_' + item.id)"
									absolute
									:color="item.backgroundColor"
									:style="{
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 2,
										width: item.width + 'px',
										height: item.height + 'px',
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
										textTransform: 'none',
										borderStyle: (item.borderWidth === 'none' ? item.borderWidth : 'solid'),
										borderRadius: item.borderRadius,
										borderWidth: item.borderWidth,
										borderColor: item.borderColor,
									}"
									v-on="on"
									v-bind="attrs"
									@click="previousPage()"
								>
									<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
								</v-btn>
								<v-btn
									v-else-if="item.type === 'Back_Button' && item.backgroundImage"
									class="hotspot_btn"
									:class="isShow ? ('d-none hotspot_btn_custom_' + item.id) : ('hotspot_btn_custom_' + item.id)"
									absolute
									:style="{
										backgroundImage: 'url(' + item.backgroundImage + ')',
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 2,
										width: item.width + 'px',
										height: item.height + 'px',
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
										textTransform: 'none',
										borderStyle: (item.borderWidth === 'none' ? item.borderWidth : 'solid'),
										borderRadius: item.borderRadius,
										borderWidth: item.borderWidth,
										borderColor: item.borderColor,
									}"
									v-on="on"
									v-bind="attrs"
									@click="previousPage()"
								>
									<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
								</v-btn>
								<a
									v-else-if="item.type === 'File_Download'"
									@click="fileDownload(item)"
									:style="{
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 2,
										width: item.width + 'px',
										height: item.height + 'px',
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform:
											'skew(' +
											item.skewX +
											'deg,' +
											item.skewY +
											'deg)',
										position: 'absolute'
									}"
									v-on="on"
									v-bind="attrs"
								></a>
								<a
									v-else
									link
									ripple="false"
									class="room-link"
									:class="isShow ? 'd-none' : ''"
									@click="linkTo(item)"
									:style="{
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 3,
										width: item.width + 'px',
										height: item.height + 'px',
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform:
											'skew(' +
											item.skewX +
											'deg,' +
											item.skewY +
											'deg)',
									}"
									v-on="on"
									v-bind="attrs"
								></a>
							</template>
							<div
								class="text-center"
								:style="{color: item.tooltip.fontColor}"
								v-html="item.tooltip.value.replace(/(?:\r\n|\r|\n)/g, '<br>')">
							</div>
						</v-tooltip>
						<div v-else>
							<img
								v-if="item.type === 'Image'"
								:src="$root.asset(item.value)"
								:class="isShow ? 'd-none' : ''"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - index : 1,
									width: item.width + 'px',
									height: item.height + 'px',
									objectFit: $root.setBackgroundSize(item.subType),
									objectPosition: $root.setBackgroundPosition(item),
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' +
										item.skewX +
										'deg,' +
										item.skewY +
										'deg)',
									position: 'absolute'
								}"
							/>
							<iframe
								v-else-if="item.type === 'Video' && !isShow"
								:class="isShow ? 'd-none' : ''"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - index : 1,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' +
										item.skewX +
										'deg,' +
										item.skewY +
										'deg)',
									position: 'absolute',
								}"
								frameborder="0"
								allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture;"
								scrolling="0"
								:src="$root.asset(item.value)"
							>
							</iframe>
							<div
								v-else-if="item.type === 'Zoom' && item.target === 'Embed' && isShowZoomEmbed == true"
								:class="isShow ? 'd-none' : ''"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - index : 999,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
									position: 'absolute',
								}"
							>
								<v-card :height="item.height + 'px'" :style="{overflow: item.height < 295 ? 'auto' : 'none'}" :loading="zoomLoading">
									<div v-if="isShowZoomIframe == false">
										<v-form v-model="zoomFormValid" @submit.prevent="joinZoom()">
											<v-row>
												<v-col cols="1" sm="1"></v-col>
												<v-col cols="10" sm="10">
													<v-text-field
														label="Zoom Name"
														v-model="zoomFullName"
														:rules="zoomFullNameRules"
														:counter="100"
														required
														name="Name"
													></v-text-field>
												</v-col>
												<v-col cols="1" sm="1"></v-col>
											</v-row>
											<v-row>
												<v-col cols="1" sm="1"></v-col>
												<v-col cols="10" sm="10">
													<v-text-field
														label="Zoom E-mail"
														v-model="zoomEmail"
														:rules="zoomEmailRules"
														required
														name="Email"
													></v-text-field>
												</v-col>
												<v-col cols="1" sm="1"></v-col>
											</v-row>
											<v-row>
												<v-col cols="1" sm="1"></v-col>
												<v-col cols="10" sm="10" class="text-center">
													<v-btn :disabled="!zoomFormValid" block type="submit" color="primary">
														Next
													</v-btn>
												</v-col>
												<v-col cols="1" sm="1"></v-col>
											</v-row>
										</v-form>
									</div>
									<div id="iframe-container" v-if="isShowZoomIframe == true"
										:style="{
											height: '100%',
											transform: 'scale(0.5)',
											transformOrigin: 'left top'
										}"
									>
										<iframe
											id="iframe"
											:style="{
												zIndex: layerMode == true ? entity.linkToDataList.length - index : 999,
												width: (item.width * 2) + 'px',
												height: (item.height * 2) -36 + 'px',
												transform:
													'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
												position: 'absolute',
												minHeight: '560px',
												marginTop: '20px'
											}"
											frameborder="0"
											allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture; camera; microphone;"
											scrolling="0"
											:src="
												baseLocation +
												'/zoom.jsp?nickname=' +
												zoomFullName +
												'&email=' +
												zoomEmail +
												'&meetingId=' +
												(item.value.includes('pwd=') ? item.value.substring(item.value.indexOf('j/') + 2, item.value.indexOf('?')) : item.value.substring(item.value.indexOf('j/') + 2, item.value.length)) +
												'&role=' +
												0 +
												'&password=' +
												(item.value.includes('pwd=') ? item.value.substring(item.value.indexOf('pwd=') + 4, item.value.length) : 'null') +
												'&disablePreview=' + ((item.disablePreview == null || item.disablePreview === '') ? true : item.disablePreview)
											"
											allowfullscreen
											@load="zoomLoad()"
										></iframe>
									</div>
								</v-card>
							</div>
							<div
								v-else-if="item.type === 'Teams' && item.target === 'Embed'"
								:class="isShow ? 'd-none' : ''"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - index : 999,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
									position: 'absolute',
								}"
							>
								<v-card :height="item.height + 'px'" :style="{overflow: item.height < 295 ? 'auto' : 'none'}" :loading="zoomLoading">
									<div id="iframe-container"
										:style="{
											height: '100%',
											transform: 'scale(0.5)',
											transformOrigin: 'left top'
										}"
									>
										<iframe
											id="iframe"
											:style="{
												zIndex: layerMode == true ? entity.linkToDataList.length - index : 999,
												width: (item.width * 2) + 'px',
												height: (item.height * 2) -36 + 'px',
												transform:
													'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
												position: 'absolute',
												minHeight: '560px',
												marginTop: '20px'
											}"
											frameborder="0"
											allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture; camera; microphone;"
											scrolling="0"
											:src="$root.getUrlTeamsWithLink(item.value)"
											allowfullscreen
											@load="zoomLoad()"
										></iframe>
									</div>
								</v-card>
							</div>
							<div
								v-else-if="item.type === 'Text'"
								class="hotspot_text"
								:class="isShow ? 'd-none' : ''"
								v-html="item.value"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - index : 2,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' +
										item.skewX +
										'deg,' +
										item.skewY +
										'deg)',
									position: 'absolute',
									backgroundColor: item.backgroundColor,
									borderStyle:
										item.borderWidth === 'none'
											? item.borderWidth
											: 'solid',
									borderWidth: item.borderWidth,
									borderColor: item.borderColor,
									padding:
										(item.padding ? item.padding : '0') +
										'px',
								}"
							></div>
							<div
								v-else-if="
									item.type === 'Embed_HTML' &&
									item.target === 'Embed'
								"
								:class="isShow ? 'd-none' : ''"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - index : 1,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' +
										item.skewX +
										'deg,' +
										item.skewY +
										'deg)',
									position: 'absolute',
									overflow: 'hidden',
								}"
								v-append="item.valueRender ? item.valueRender : item.value"
							></div>
							<v-btn
								v-else-if="item.type === 'Button' && !item.backgroundImage"
								class="hotspot_btn"
								:class="isShow ? ('d-none hotspot_btn_custom_' + item.id) : ('hotspot_btn_custom_' + item.id)"
								absolute
								:color="item.backgroundColor"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - index : 2,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
									textTransform: 'none',
									borderStyle: (item.borderWidth === 'none' ? item.borderWidth : 'solid'),
									borderRadius: item.borderRadius,
									borderWidth: item.borderWidth,
									borderColor: item.borderColor,
								}"
							>
								<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
							</v-btn>
							<v-btn
								v-else-if="item.type === 'Button' && item.backgroundImage"
								class="hotspot_btn"
								:class="isShow ? ('d-none hotspot_btn_custom_' + item.id) : ('hotspot_btn_custom_' + item.id)"
								absolute
								:style="{
									backgroundImage: 'url(' + item.backgroundImage + ')',
									zIndex: layerMode == true ? entity.linkToDataList.length - index : 2,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
									textTransform: 'none',
									borderStyle: (item.borderWidth === 'none' ? item.borderWidth : 'solid'),
									borderRadius: item.borderRadius,
									borderWidth: item.borderWidth,
									borderColor: item.borderColor,
								}"
							>
								<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
							</v-btn>
								<v-btn
									v-else-if="item.type === 'Back_Button' && !item.backgroundImage"
									class="hotspot_btn"
									:class="isShow ? ('d-none hotspot_btn_custom_' + item.id) : ('hotspot_btn_custom_' + item.id)"
									absolute
									:color="item.backgroundColor"
									:style="{
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 2,
										width: item.width + 'px',
										height: item.height + 'px',
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
										textTransform: 'none',
										borderStyle: (item.borderWidth === 'none' ? item.borderWidth : 'solid'),
										borderRadius: item.borderRadius,
										borderWidth: item.borderWidth,
										borderColor: item.borderColor,
									}"
									@click="previousPage()"
								>
									<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
								</v-btn>
								<v-btn
									v-else-if="item.type === 'Back_Button' && item.backgroundImage"
									class="hotspot_btn"
									:class="isShow ? ('d-none hotspot_btn_custom_' + item.id) : ('hotspot_btn_custom_' + item.id)"
									absolute
									:style="{
										backgroundImage: 'url(' + item.backgroundImage + ')',
										zIndex: layerMode == true ? entity.linkToDataList.length - index : 2,
										width: item.width + 'px',
										height: item.height + 'px',
										top: item.posY + 'px',
										left: item.posX + 'px',
										transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
										textTransform: 'none',
										borderStyle: (item.borderWidth === 'none' ? item.borderWidth : 'solid'),
										borderRadius: item.borderRadius,
										borderWidth: item.borderWidth,
										borderColor: item.borderColor,
									}"
									@click="previousPage()"
								>
									<div v-html="item.css ? (item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>') : item.value"></div>
								</v-btn>
							<a
								v-else-if="item.type === 'File_Download'"
								@click="fileDownload(item)"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - index : 2,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' +
										item.skewX +
										'deg,' +
										item.skewY +
										'deg)',
									position: 'absolute'
								}"
							></a>
							<a
								v-else
								link
								ripple="false"
								class="room-link"
								:class="isShow ? 'd-none' : ''"
								@click="linkTo(item)"
								:style="{
									zIndex: layerMode == true ? entity.linkToDataList.length - index : 3,
									width: item.width + 'px',
									height: item.height + 'px',
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' +
										item.skewX +
										'deg,' +
										item.skewY +
										'deg)',
								}"
							></a>
						</div>
					</div>
				</div>
			</div>

			<v-dialog
				v-model="dialogZoom.show"
				no-click-animation
				persistent
				style="overflow: hidden"
				fullscreen
			>
				<v-card :loading="zoomLoading">
					<v-card-title class="headline">
						<v-spacer></v-spacer>
						<v-btn
							icon
							@click="closeZoomDialog()"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-row style="width: 99%; margin-left: 10px">
						<v-col cols="12" :sm="smLeft">
								<div v-if="embedHtmlBeside.status == 'Left'" v-append="embedHtmlBeside.value"
									:style="{
											overflow: 'auto',
											height: heightEmbedHtmlBeside
									}"
								></div>
						</v-col>
						<v-col cols="12" :sm="smCenter">
							<v-card
								v-if="isShowZoomIframe == false"
								:class="isShow ? 'd-none' : ''"
								:style="{
									zIndex: 1,
									width: '100%',
									height: '50vh',
								}"
							>
								<v-form v-model="zoomFormValid" @submit.prevent="joinZoom()">
									<v-row>
										<v-col cols="1" sm="1"></v-col>
										<v-col cols="10" sm="10">
											<v-text-field
												label="Zoom Name"
												v-model="zoomFullName"
												:rules="zoomFullNameRules"
												:counter="100"
												required
												name="Name"
											></v-text-field>
										</v-col>
										<v-col cols="1" sm="1"></v-col>
									</v-row>
									<v-row>
										<v-col cols="1" sm="1"></v-col>
										<v-col cols="10" sm="10">
											<v-text-field
												label="Zoom E-mail"
												v-model="zoomEmail"
												:rules="zoomEmailRules"
												required
												name="Email"
											></v-text-field>
										</v-col>
										<v-col cols="1" sm="1"></v-col>
									</v-row>
									<v-row>
										<v-col cols="1" sm="1"></v-col>
										<v-col cols="10" sm="10" class="text-center">
											<v-btn :disabled="!zoomFormValid" block type="submit" color="primary">
												Next
											</v-btn>
										</v-col>
										<v-col cols="1" sm="1"></v-col>
									</v-row>
								</v-form>
							</v-card>
							<iframe
								v-else
								:class="isShow ? 'd-none' : ''"
								:style="{
									zIndex: 1,
									width: '100%',
									height: '93.5vh',
								}"
								frameborder="0"
								allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture; camera; microphone;"
								scrolling="0"
								:src="
									baseLocation +
									'/zoom.jsp?nickname=' +
									zoomFullName +
									'&email=' +
									zoomEmail +
									'&meetingId=' +
									(dialogZoom.value.includes('pwd=') ? dialogZoom.value.substring(dialogZoom.value.indexOf('j/') + 2, dialogZoom.value.indexOf('?')) : dialogZoom.value.substring(dialogZoom.value.indexOf('j/') + 2, dialogZoom.value.length)) +
									'&role=' +
									0 +
									'&password=' +
									(dialogZoom.value.includes('pwd=') ? dialogZoom.value.substring(dialogZoom.value.indexOf('pwd=') + 4, dialogZoom.value.length) : 'null') +
									'&disablePreview=' + ((dialogZoom.disablePreview == null || dialogZoom.disablePreview === '') ? true : dialogZoom.disablePreview)
								"
								allowfullscreen
								@load="zoomLoad()"
							></iframe>
						</v-col>
						<v-col cols="12" :sm="smRight">
							<div v-if="embedHtmlBeside.status == 'Right'" v-append="embedHtmlBeside.value"
								:style="{
									overflow: 'auto',
									height: heightEmbedHtmlBeside
								}"
							></div>
						</v-col>
					</v-row>
					<div v-if="embedHtmlBelow" v-append="embedHtmlBelow" style="margin: 20px"
						:style="{
							overflow: 'auto',
							height: heightEmbedHtmlBelow
						}"
					></div>
					<br>
				</v-card>
			</v-dialog>

			<v-dialog
				v-model="dialogTeams.show"
				no-click-animation
				persistent
				style="overflow: hidden"
				fullscreen
			>
				<v-card>
					<v-card-title class="headline">
						<v-spacer></v-spacer>
						<v-btn
							icon
							@click="dialogTeams.show = false"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-row style="width: 99%; margin-left: 10px">
						<v-col cols="12" :sm="smLeft">
								<div v-if="embedHtmlBeside.status == 'Left'" v-append="embedHtmlBeside.value"
									:style="{
											overflow: 'auto',
											height: heightEmbedHtmlBeside
									}"
								></div>
						</v-col>
						<v-col cols="12" :sm="smCenter">
							<iframe
								:class="isShow ? 'd-none' : ''"
								:style="{
									zIndex: 1,
									width: '100%',
									height: '93.5vh',
								}"
								frameborder="0"
								allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture; camera; microphone;"
								scrolling="0"
								:src="$root.getUrlTeamsWithLink(dialogTeams.value)"
								allowfullscreen
								@load="zoomLoad()"
							></iframe>
						</v-col>
						<v-col cols="12" :sm="smRight">
							<div v-if="embedHtmlBeside.status == 'Right'" v-append="embedHtmlBeside.value"
								:style="{
									overflow: 'auto',
									height: heightEmbedHtmlBeside
								}"
							></div>
						</v-col>
					</v-row>
					<div v-if="embedHtmlBelow" v-append="embedHtmlBelow" style="margin: 20px"
						:style="{
							overflow: 'auto',
							height: heightEmbedHtmlBelow
						}"
					></div>
					<br>
				</v-card>
			</v-dialog>

			<v-dialog
				v-model="dialogProtectRoom"
				no-click-animation
				persistent
				transition="dialog-bottom-transition"
				content-class="col-sm-7 col-12 hide-box-shadow"
				style="overflow: hidden"
				overlay-color="black"
				overlay-opacity="1"
				max-width="500"
			>
				<v-form
					ref="formPasswordProtectRoom"
					v-model="validPasswordProtectRoom"
					@submit.prevent="checkPasswordProtectRoom"
				>
					<v-card>
						<v-card-title
							class="headline warning justify-center pa-12"
							primary-title
						>
							<v-icon color="white" size="120"
								>mdi-alert-circle-outline</v-icon
							>
						</v-card-title>

						<v-card-text class="pa-6" style="text-align: center">
							<span class="title">Warning</span>
							<br />
							<br />
							<p style="text-align: justify">
								The Room is password protected. Please enter the
								password.
							</p>
							<v-text-field
								v-model="passwordProtect"
								:rules="[
									(v) =>
										!!v || 'Password Protect Room is required',
								]"
								:type="passwordFieldType"
								:append-icon="
									passwordFieldType === 'password'
										? 'mdi-eye'
										: 'mdi-eye-off'
								"
								@click:append="switchVisibility"
								label="Password Protect Room"
								outlined
							></v-text-field>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="default" @click="goBack()">Cancel</v-btn>
							<v-btn
								:disabled="!validPasswordProtectRoom"
								color="primary"
								type="submit"
								>Confirm</v-btn
							>
							<v-spacer></v-spacer>
						</v-card-actions>
					</v-card>
				</v-form>
			</v-dialog>

			<v-dialog
				eager
				v-model="dialog.show"
				no-click-animation
				persistent
				transition="dialog-bottom-transition"
				:content-class="$vuetify.breakpoint.mobile ? 'pa-0 col-12 hide-box-shadow' : 'col-sm-7 col-12 hide-box-shadow'"
				:fullscreen="$vuetify.breakpoint.mobile"
				style="overflow: hidden"
				@click="iframeControl('')"
			>
				<v-card :style="{backgroundColor: dialog.transparent}" :tile="$vuetify.breakpoint.mobile">
					<v-card-title class="headline" :style="{backgroundColor: dialog.backgroundColor}">
						{{ dialog.title }}
						<v-spacer></v-spacer>
						<v-btn
							icon
							@click="closeDialog(), iframeControl('')"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>

					<img
						v-if="$root.isImage(dialog.content)"
						:src="$root.asset(dialog.content)"
						:style="{
							width: '100%',
							height: '100%',
							right: '0',
							bottom: '0',
							backgroundColor: dialog.backgroundColor
						}"
					/>
					<div v-else ref="embedHtmlContainer" id="iframe-container" :style="{backgroundColor: dialog.backgroundColor, overflow: 'auto'}">
						<div
							v-if="dialog.contentType === 'Embed_HTML'"
							v-append="dialog.content"
							class="hotspot_embed_html"
							id="embedHtml"
						></div>
						<iframe
							v-else
							frameborder="0"
							allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture;camera;microphone"
							scrolling="0"
							id="iframe"
							:src="$root.asset(dialog.content)"
							allowfullscreen
						></iframe>
					</div>
				</v-card>
			</v-dialog>
			<v-dialog
				v-model="presentationDialog.show"
				no-click-animation
				persistent
				transition="dialog-bottom-transition"
				style="overflow: hidden"
				width="auto "
				:fullscreen="$vuetify.breakpoint.xsOnly"
			>
				<v-card width="1024px"  color="rgb(0, 0, 0, 0.2)">
					<v-card-title class="headline">
						<v-spacer></v-spacer>
						<v-btn icon @click="presentationDialog.show = false" style="background-color: white">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-row
							v-for="(item, index) in presentationScheduleList"
							:key="index"
							style="margin-left: 0; margin-right: 0"
						>
							<v-card width="100%" style="margin-bottom:1em">
								<v-row align="center" justify="center">
									<v-col cols="8" sm="8">
										<h3 style="color: black ; margin-left:1em">
											{{ item.presentation.title }}
										</h3>
									</v-col>
									<v-col cols="4" sm="4" >
										<h3 style="text-align: right; margin-right:1em"
											>{{
												formatDate(item.dataMap.startDate)
												+ " " + formatTime12Hours(item.startTime)
												+ " (" + item.timezone+")"
											}}
											</h3>
									</v-col>
								</v-row>
								<v-divider style="margin: 12px;"></v-divider>
								<v-row >
									<v-col cols="3" sm="3" align="center">
										<div>
											<div

												v-for="(presenter, idxPresenter) in item
													.presentation
													.presenterClinicList"
												:key="idxPresenter"
											>
											<div style="text-align: center;">
												<v-row align="center" justify="center" style="float:center;">
												<v-avatar
													size="84px"
													color="teal"
													style="
														margin-left: 16px;
														margin-right: 12px;
														cursor: pointer;
													"
													@click="
														selectedPresenterName = presenterName(
															presenter
														);
														selectedPresenterBio =
															presenter.bio;
														dialogBio = true;
													"
												>
													<img
														v-if="
															presenter.image ==
															null
														"
														:src="
															baseLocation +
															'/resource/image/default-avatar.png'
														"
													/>
													<img
														v-else
														:src="
															baseLocation +
															'/asset/file/user/' +
															presenter.image
														"
													/>
												</v-avatar>
												</v-row>
												<v-row align="center" justify="center" style="margin-left: 12px; margin-right: 12px;">
													<a
														style="
															color: black;
															text-decoration: none;
															text-align: center;
															font-weight: bold;
														"
														@click="
															selectedPresenterName = presenterName(
																presenter
															);
															selectedPresenterBio =
																presenter.bio;
															dialogBio = true;
														"
														>{{
															presenterName(
																presenter
															)
														}}</a
													>
												</v-row>
											</div>

											</div>
										</div>

									</v-col>
									<v-col class="d-flex" cols="5" sm="5">
										<p
											class="mt-4 body-2"
											style="color: black; text-align: justify;"
											v-html="
												item.presentation.description
											"
										></p>
									</v-col>
									<v-col  cols="4" sm="4">
										<ul style="font-weight:bold; color: black; text-align: center; list-style-type:none; margin-right:1em;">
											<li style="padding: 0.5em; padding-right:1em; float: left;">
												<h4>{{formatDays(item.dataMap.toStartTime)}}</h4>
												<h4>Days</h4>
											</li>
											<li style="padding: 0.5em; padding-right:1em; float: left;">
												<h4>{{formatHours(item.dataMap.toStartTime)}}</h4>
												<h4>Hours</h4>
											</li>
											<li style="padding: 0.5em; padding-right:1em; float: left;">
												<h4>{{formatMinutes(item.dataMap.toStartTime)}}</h4>
												<h4>Minutes</h4>
											</li>
											<li style="padding: 0.5em; padding-right:1em; float: left;">
												<h4>{{formatSeconds(item.dataMap.toStartTime)}}</h4>
												<h4>Seconds</h4>
											</li>
										</ul>
										<br/>
									</v-col>
								</v-row>

								<v-row class="d-flex mx-4">
									<v-col cols="12" sm="12" style="margin:0; padding-right:0;">
										<section style="float: right;">
												<v-btn
													v-if="
														item.presentation
															.type ==
														typeOnDemandVideo
													"
													color="primary"
													class="d-flex ma-2 px-12"
													@click="enterPresentation(item.presentation);"
													>Enter Presentation</v-btn
												>
												<v-btn
													v-else-if="
														item.presentation.type == typeZoomWebinar &&
														(!item.presentation.dataMap || !item.presentation.dataMap.zoomTarget || item.presentation.dataMap.zoomTarget == 'New Tab') &&
														item.dataMap.toEndTime >= 0
													"
													color="primary"
													class="d-flex  ma-2 px-12"
													:href="
														item.presentation
															.participantUrl
													"
													target="_blank"
													>Enter Presentation</v-btn
												>
												<v-btn
													v-else-if="
														item.presentation.type == typeZoomWebinar &&
														(item.presentation.dataMap && item.presentation.dataMap.zoomTarget && item.presentation.dataMap.zoomTarget == 'Dialog') &&
														item.dataMap.toEndTime >= 0
													"
													color="primary"
													class="d-flex  ma-2 px-12"
													@click="showZoomPresentation(item.presentation)"
													>Enter Presentation</v-btn
												>
												<v-btn
													v-else-if="
														item.presentation.type == typeTeamsMeeting &&
														(!item.presentation.dataMap || !item.presentation.dataMap.target || item.presentation.dataMap.target == 'New Tab') &&
														item.dataMap.toEndTime >= 0
													"
													color="primary"
													class="d-flex  ma-2 px-12"
													:href="
														item.presentation
															.participantUrl
													"
													target="_blank"
													>Enter Presentation</v-btn
												>
												<v-btn
													v-else-if="
														item.presentation.type == typeTeamsMeeting &&
														(!item.presentation.dataMap || !item.presentation.dataMap.target || item.presentation.dataMap.target == 'Dialog') &&
														item.dataMap.toEndTime >= 0
													"
													color="primary"
													class="d-flex  ma-2 px-12"
													@click="showTeamsPresentation(item.presentation)"
													>Enter Presentation</v-btn
												>
												<v-btn
													v-else-if="
														item.presentation.type == typeZoomMeeting &&
														(!item.presentation.dataMap || !item.presentation.dataMap.zoomTarget || item.presentation.dataMap.zoomTarget == 'New Tab') &&
														item.dataMap.toEndTime >= 0
													"
													color="primary"
													class="d-flex  ma-2 px-12"
													:href="
														item.presentation
															.participantUrl
													"
													target="_blank"
													>Enter Presentation</v-btn
												>
												<v-btn
													v-else-if="
														item.presentation.type == typeZoomMeeting &&
														(item.presentation.dataMap && item.presentation.dataMap.zoomTarget && item.presentation.dataMap.zoomTarget == 'Dialog') &&
														item.dataMap.toEndTime >= 0
													"
													color="primary"
													class="d-flex  ma-2 px-12"
													@click="showZoomPresentation(item.presentation)"
													>Enter Presentation</v-btn
												>
												<v-btn
													v-else-if="
														item.presentation
															.type ==
															typePreRecordedVideo &&
														item.dataMap
															.toStartTime <= 600
													"
													color="primary"
													class="d-flex  ma-2 px-12"
													@click="enterPresentation(item.presentation);"
													>Enter Presentation</v-btn
												>
												<v-btn
													v-else-if="
														item.presentation
															.type ==
															typeVimeoLive &&
														item.dataMap
															.toEndTime >= 0
													"
													color="primary"
													class="d-flex ma-2 px-12"
													@click="
														videoIframe =
															item.presentation
																.videoIframe;
														dialogIframe = true;
													"
													>Enter Presentation</v-btn
												>
										</section>
										<section>
												<span
													v-if="
														(item.presentation
															.type ==
															typeZoomWebinar ||
															item.presentation
																.type ==
																typeZoomMeeting ||
															item.presentation
																.type ==
																typeVimeoLive) &&
														item.dataMap.toEndTime <
															0
													"
													>This live session has
													ended</span
												>
										</section>
										<section class="accordion">
											<br/>
											<input
												type="checkbox"
												name="collapse"
												:id="item.presentation.id"
											/>
											<div
												class="handle d-flex flex-row align-center"
											>
												<label
													style="color: black"
													:for="item.presentation.id"
													v-show="
														item.presentation
															.handoutList &&
														item.presentation
															.handoutList
															.length > 0
													"
												>
													Resources
													<i></i>
												</label>
												<v-spacer></v-spacer>
											</div>
											<div
												class="content"
												v-for="(itemHandout, idxItemHandout) in item
													.presentation.handoutList"
												:key="idxItemHandout"
											>
												<v-row
													class="py-2"
													v-if="itemHandout"
												>
													<v-col cols="12" sm="6">
														<v-icon
															>mdi-file-document-outline</v-icon
														>
														<span>{{
															itemHandout.title
														}}</span>
													</v-col>
													<v-col cols="12" sm="8">
													</v-col>
													<v-col cols="12" sm="4">
														<v-btn
															small
															color="primary"
															class="mx-4 px-5"
															v-if="itemHandout"
															@click="
																downloadHandout(
																	itemHandout.value
																)
															"
															>View</v-btn
														>
													</v-col>
												</v-row>
												<hr
													class="mx-n4"
													v-if="itemHandout.id"
												/>
											</div>
										</section>
									</v-col>
								</v-row>
							</v-card>
						</v-row>
					</v-card-text>
				</v-card>
			</v-dialog>
			<v-row v-if="$store.state.isPoweredBy" class="ml-0" style="background-color: black" :style="{ marginTop: footerMarginTop, width: footerWidth }">
				<v-col cols="12" sm="12">
					<div id="v-footer" style="height: 50px; background-color: black" v-if="$store.state.footerText === ''">
						<p class="text-center" style="color: #cccccc;padding-top: 15px">Powered by <a href="https://v-unite.com/" target="_blank" style="color:#cccccc">V-Unite</a></p>
					</div>
                    <div id="v-footer" style="height: 50px; background-color: black" v-else>
						<p class="text-center" style="color: #cccccc;padding-top: 15px">{{ $store.state.footerText }}</p>
					</div>
				</v-col>
			</v-row>

			<v-dialog v-model="dialogBio" persistent width="800">
				<v-card tile>
					<v-card-title>
						<span class="headline">{{
							selectedPresenterName
						}}</span>
						<v-spacer></v-spacer>
						<v-icon @click="dialogBio = false">mdi-close</v-icon>
					</v-card-title>
					<v-divider class="mx-4"></v-divider>
					<v-card-text>{{ selectedPresenterBio }}</v-card-text>
				</v-card>
			</v-dialog>
			<v-dialog v-model="dialogVideo" persistent width="800">
				<v-card tile>
					<v-card-title>
						<v-spacer></v-spacer>
						<v-icon
							@click="
								dialogVideo = false;
								videoUrl = null;
							"
							>mdi-close</v-icon
						>
					</v-card-title>
					<v-divider class="mx-4"></v-divider>
					<div id="iframe-container">
						<iframe
							frameborder="0"
							allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture;camera;microphone"
							scrolling="0"
							id="iframe"
							:src="videoUrl"
							allowfullscreen
						></iframe>
					</div>
				</v-card>
			</v-dialog>
			<v-dialog v-model="dialogVideoWithEmbedHtml" persistent fullscreen dark>
				<v-card tile>
					<v-card-title>
						<v-spacer></v-spacer>
						<v-icon
							@click="
								dialogVideoWithEmbedHtml = false;
								videoUrl = null;
							"
							>mdi-close</v-icon
						>
					</v-card-title>
					<v-divider class="mx-4"></v-divider>
					<v-row style="width: 99%; margin-left: 10px">
						<v-col cols="12" :sm="smLeft">
								<div v-if="embedHtmlBeside.status == 'Left'" v-append="embedHtmlBeside.value"
									:style="{
										overflow: 'auto',
										height: heightEmbedHtmlBeside + 'px'
									}"
								></div>
						</v-col>
						<v-col cols="12" :sm="smCenter">
							<div id="iframe-container" ref="contentPresentation">
								<iframe
									frameborder="0"
									allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture;"
									scrolling="0"
									id="iframe"
									:src="videoUrl"
									allowfullscreen
								></iframe>
							</div>
						</v-col>
						<v-col cols="12" :sm="smRight">
							<div v-if="embedHtmlBeside.status == 'Right'" v-append="embedHtmlBeside.value"
								:style="{
									overflow: 'auto',
									height: heightEmbedHtmlBeside + 'px'
								}"
							></div>
						</v-col>
					</v-row>
					<div v-if="embedHtmlBelow" v-append="embedHtmlBelow" style="margin: 20px"
						:style="{
							overflow: 'auto',
							height: heightEmbedHtmlBelow + 'px'
						}"
					></div>
					<br>
				</v-card>
			</v-dialog>
			<v-dialog v-model="dialogIframe" persistent width="800">
				<v-card tile>
					<v-card-title>
						<v-spacer></v-spacer>
						<v-icon
							@click="
								dialogIframe = false;
								videoIframe = null;
							"
							>mdi-close</v-icon
						>
					</v-card-title>
					<v-divider class="mx-4"></v-divider>
					<div v-html="videoIframe"></div>
				</v-card>
			</v-dialog>
			<span
				style="display: none"
				v-for="(item, index) in entityList"
				:key="index"
			>
				<img :src="$root.asset(item.background)" />
			</span>
			
			<v-dialog
				v-model="linkTypeDialog.show"
				no-click-animation
				persistent
				transition="dialog-bottom-transition"
				content-class="col-sm-7 col-12 hide-box-shadow ma-0 pa-0"
				style="overflow: hidden"
				scrollable
				max-width="95%"
			>
				<v-card :style="{backgroundColor: linkTypeDialog.transparent}">
					<v-card-title class="headline" :style="{backgroundColor: linkTypeDialog.backgroundColor}">
						<v-spacer></v-spacer>
						<v-btn icon @click="linkTypeDialog.show = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text :style="{backgroundColor: linkTypeDialog.backgroundColor}">
						<span>
							<div v-html="linkTypeDialog.content"></div>
						</span>
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog
				v-model="productDialog.show"
				no-click-animation
				persistent
				transition="dialog-bottom-transition"
				content-class="col-sm-7 col-12 hide-box-shadow ma-0 pa-0"
				style="overflow: hidden"
			>
				<v-card rounded="0">
					<v-card-title>
						<v-spacer></v-spacer>
						<v-btn icon @click="productDialog.show = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-container>
						<v-row dense>
							<v-card
								class="ma-0 pa-0"
								width="100%"
								v-for="(product, index) in productDialog.content"
								:key="index"
							>
								<v-col class="pb-0" cols="12">
									<div
										class="d-flex justify-space-between"
									>
										<div>
											<v-card-title
												class="headline"
												v-text="product.name"
											></v-card-title>
											<v-card-text
												v-text="product.description"
											></v-card-text>
										</div>
										<v-avatar class="d-flex ma-3" size="125" tile>
											<v-img
												:src="
													$root.asset(product.image)
												"
												contain
											></v-img>
										</v-avatar>
									</div>
								</v-col>
								<v-col class="pt-0" cols="12">
									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn
											class="ml-2 mt-5"
											color="secondary"
											:href="product.urlLink"
											target="_blank"
											>{{product.buttonName}}</v-btn
										>
									</v-card-actions>
								</v-col>
							</v-card>
						</v-row>
					</v-container>
				</v-card>
			</v-dialog>
			<v-dialog
				v-model="clinicBookDialog.show"
				no-click-animation
				persistent
				transition="dialog-bottom-transition"
				content-class="col-sm-7 col-12 pa-0 hide-box-shadow"
				style="overflow: auto"
				@click="iframeControl('')"
			>
				<v-card rounded="0">
					<v-card-text>
						<v-flex row-wrap justify-center>
							<v-row align="center" justify="center">
								<v-col class="pa-0">
									<v-card flat>
										<v-card-title class="headline">
											{{ clinicBookDialog.title }}
											<v-spacer></v-spacer>
											<v-btn
												icon
												@click="
													((clinicBookDialog.show = false),
													(isSubmitted = false)),
														iframeControl('')
												"
											>
												<v-icon>mdi-close</v-icon>
											</v-btn>
										</v-card-title>
										<v-divider></v-divider>
										<v-card-text
											class="pa-5"
											v-if="!isSubmitted"
										>
											<form @submit="clinicSubmitBook">
												<v-text-field
													ref="clinic_input_name"
													label="Name"
													v-model="clinic_input_name"
													:rules="[
														() =>
															!!clinic_input_name ||
															'Name is required',
													]"
													required
												></v-text-field>

												<v-text-field
													ref="clinic_input_email"
													label="Email"
													v-model="clinic_input_email"
													:rules="[
														(v) =>
															/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
																v
															) ||
															'E-mail is required and must be valid',
													]"
													required
												></v-text-field>

												<v-text-field
													ref="clinic_input_phone"
													label="Phone"
													type="number"
													v-model="clinic_input_phone"
													:rules="[
														() =>
															!!clinic_input_phone ||
															'Phone is required',
													]"
													required
												></v-text-field>

												<v-textarea
													ref="clinic_input_req"
													label="Note"
													v-model="clinic_input_req"
													:rules="[
														() =>
															!!clinic_input_req ||
															'Requirement is required',
													]"
													required
												></v-textarea>
												<p></p>

												<v-btn
													class="green darken-1"
													type="submit"
													dark
													>{{ clinicBookDialog.name }}</v-btn
												>
											</form>
										</v-card-text>
										<v-card-text v-else>
											<h2
												class="black--text text--lighten-1"
											>
												{{ clinicBookResponse }}
											</h2>
										</v-card-text>
									</v-card>
								</v-col>
							</v-row>
						</v-flex>
					</v-card-text>
				</v-card>
			</v-dialog>
			<v-dialog
				v-model="clinicConsultationDialog.show"
				no-click-animation
				persistent
				transition="dialog-bottom-transition"
				content-class="col-sm-7 col-12 hide-box-shadow"
				style="overflow: hidden"
				@click="iframeControl('')"
			>
				<v-row align="center" justify="center">
					<v-col cols="8">
						<v-card>
							<v-card-title class="headline">
								Welcome to your consultation
								<v-spacer></v-spacer>
								<v-btn
									icon
									@click="
										(clinicConsultationDialog.show = false),
											iframeControl('')
									"
								>
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text class="pa-5">
								<div class="black--text text--lighten-1">
									Please enter your email address and the
									password that have been emailed to you.<br />
									Once validated, you will be redirected to
									join a Zoom meeting consultation session.<br />
									If you have not yet booked a consultation
									and would like to book one, please click
									<a
										@click="
											clinicConsultationDialog.show = false;
											clinicBookDialog.show = true;
										"
										sytle="color:red"
										>here</a
									>.
								</div>
								<p></p>
								<form @submit="clinicSubmitBook">
									<v-text-field
										ref="consulEmail"
										label="Email"
										v-model="consulEmail"
										:rules="[
											(v) =>
												/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
													v
												) ||
												'E-mail is required and must be valid',
										]"
										required
									>
									</v-text-field>

									<v-text-field
										:type="passwordFieldType"
										label="Password"
										v-model="password"
										:append-icon="
											this.passwordFieldType ===
											'password'
												? 'mdi-eye'
												: 'mdi-eye-off'
										"
										@click:append="switchVisibility"
										required
									></v-text-field>

									<v-btn
										class="green darken-1"
										type="submit"
										@click="clinicConsultation"
										dark
										>Attend Consultation</v-btn
									>
								</form>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-dialog>

			<v-dialog
				v-model="dialogImageSlider.show"
				no-click-animation
				persistent
				transition="dialog-bottom-transition"
				content-class="col-sm-8 col-12 hide-box-shadow"
			>
				<v-card :style="{backgroundColor: dialogImageSlider.transparent}">
					<v-card-title class="headline" :style="{backgroundColor: dialogImageSlider.backgroundColor}">
						<v-spacer></v-spacer>
						<v-btn icon @click="dialogImageSlider.show = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text
						:style="{
							maxHeight: '76vh !important',
							overflowY: 'auto',
							backgroundColor: dialogImageSlider.backgroundColor
						}"
					>
						<v-row justify="center">
							<v-col
								v-for="(
									item, index
								) in dialogImageSlider.images"
								:key="index"
								class="d-flex child-flex col-sm-2 col-6"
							>
								<v-hover v-slot="{ hover }">
									<v-card :elevation="hover ? 12 : 2">
										<v-img
											:src="!item.endsWith('.pdf') ? $root.asset(item) : $root.asset(item).replace('.pdf', '.jpg')"
											:lazy-src="!item.endsWith('.pdf') ? $root.asset(item) : $root.asset(item).replace('.pdf', '.jpg')"
											aspect-ratio="1"
											class="grey lighten-2"
										>
											<template v-slot:placeholder>
												<v-row
													class="fill-height ma-0"
													align="center"
													justify="center"
												>
													<v-progress-circular
														indeterminate
														color="grey lighten-5"
													></v-progress-circular>
												</v-row>
											</template>
											<div
												@click="
													(dialogCarousel = Object.assign(
														{},
														dialogImageSlider
													)),
														(dialogCarousel.open = index),
														sendToGA(dialogCarousel)
												"
												:class="
													hover ? 'd-flex' : 'd-none'
												"
												class="justify-center align-center"
												style="
													height: 100%;
													background-color: rgba(
														0,
														0,
														0,
														0.5
													);
													cursor: pointer;
												"
											>
												<v-icon large dark>
													mdi-magnify-plus
												</v-icon>
											</div>
										</v-img>
									</v-card>
								</v-hover>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog
				v-model="dialogCarousel.show"
				no-click-animation
				persistent
				content-class="col-12 hide-box-shadow"
				fullscreen
			>
				<v-card>
					<v-card-title class="headline">
						<v-spacer></v-spacer>
						<v-btn icon @click="dialogCarousel.show = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-carousel
							v-model="dialogCarousel.open"
							hide-delimiters
							class="custom-slider"
							height="89vh"
							@change="sendToGA(dialogCarousel)"
						>
							<v-carousel-item
								class="text-center"
								v-for="(item, index) in dialogCarousel.images"
								:key="index"
								reverse-transition="fade"
								transition="fade"
							>
								<div  v-if="!item.endsWith('.pdf')"
									:style="{
										backgroundImage: 'url(' + $root.asset(item).replace(/\\/g,'/').replace(/ /g, '%20') + ')',
										backgroundRepeat: 'no-repeat',
										backgroundSize: 'contain !important',
										backgroundPosition: 'center',
										height: '100%',
										width: '100%'
									}"
								>
								</div>
								<iframe v-else
									frameborder="0"
									allow="autoplay; encrypted-media"
									scrolling="0"
									width="100%"
									class="iframe-size"
									:src="$root.asset(item)"
									allowfullscreen
									style="height:100%"
								></iframe>
							</v-carousel-item>
						</v-carousel>
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog v-model="$store.state.notification.show" width="500" v-if="$store.state.notification.title != 'Unknown error'">
				<v-card style="padding: 20px">
					<!-- <div style="display: flex; justify-content: space-between">
						<h2 style="margin-bottom: 10px">
							Whoops! ({{ $store.state.notification.title }})
						</h2>
						<v-btn
							icon
							color="secondary"
							@click="closeNotification"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</div> -->
				
					<div class="text-center mb-5">
						<h2 style="margin-bottom: 10px; font-size: larger;"
						>Something Went Wrong</h2>
					</div>

					<template
						v-if="
							$store.state.notification.content &&
							$store.state.notification.content.type ==
								'NOTIFICATION'
						"
					>
						<div
							style="color: #c42126; font-size: 14px"
							:key="index"
							v-for="(item, index) in $store.state.notification.content
								.fieldErrorList"
						>
							{{ item }}
						</div>
						<div
							style="color: #ed5025; font-size: 14px"
							:key="index"
							v-for="(item, index) in $store.state.notification.content
								.errorList"
						>
							{{ item }}
						</div>
						<div
							style="color: #e26026; font-size: 14px"
							:key="index"
							v-for="(item, index) in $store.state.notification.content
								.noticeList"
						>
							{{ item }}
						</div>
					</template>
					<template v-else>
						<div style="color: #e26026; font-size: 14px">
							{{ $store.state.notification.content }}
						</div>
					</template>
					<div class="text-center mt-5 mr-10 ml-10">
						<p style="font-size: 10px; font-weight: bold;">If this issue persists please contact us through our email with a screenshot at <span 
						style="color:blue; text-decoration: underline;">support@v-unite.com</span></p>
					</div>
					<div style="text-align: center; margin-top: 20px">
						<v-btn color="#009ec1" @click="closeNotification"
							>Close</v-btn
						>
					</div>
				</v-card>
			</v-dialog>

			<v-dialog
				v-model="dialogInfo"
				no-click-animation
				persistent
				transition="dialog-bottom-transition"
				content-class="col-sm-7 col-12 hide-box-shadow"
				style="overflow: hidden"
				overlay-color="black"
				overlay-opacity="1"
				max-width="500"
			>
				<v-card max-width="500">
					<v-card-title
						class="headline info justify-center pa-12"
						primary-title
					>
						<v-icon color="white" size="120"
							>mdi-alert-circle-outline</v-icon
						>
					</v-card-title>
					<v-card-text
						v-if="entity.transitMap.isNotReady"
						class="text-center pa-6"
					>
						<span class="headline"
							>{{ entity.transitMap.experienceName }} is not ready
							yet.
						</span>
						<br />
						<br />
						<p>
							The clinic will open from
							{{ entity.transitMap.startDate }}<br />to
							{{ entity.transitMap.endDate }}
						</p>
					</v-card-text>
					<v-card-text
						v-else-if="entity.transitMap.isExpired"
						class="text-center pa-6"
					>
						<span class="headline"
							>{{ entity.transitMap.experienceName }} is expired.
						</span>
						<br />
						<br />
						<p>
							The clinic was open from {{ entity.transitMap.startDate
							}}<br />to {{ entity.transitMap.endDate }}
						</p>
					</v-card-text>
					<v-card-text
						v-else
						class="text-center pa-6"
					>
						<span class="headline"
							>{{ experience.name }} is not yet active/published.
						</span>
						<br />
						<br />
						<div v-if="experience.dataMap.ongoing == false">
							<p>
								The clinic was open from {{ experience.transitMap.startDateText
								}}<br />to {{ experience.transitMap.endDateText }}
							</p>
						</div>
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog
				v-model="dialogFileUpload.show"
				no-click-animation
				persistent
				content-class="col-sm-4 col-12 hide-box-shadow"
			>
				<v-card>
					<v-card-title class="headline">
						<v-spacer></v-spacer>
						<v-btn
							icon
							@click="dialogFileUpload.show = false"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text style="max-height: 76vh !important; overflow-y: auto;">
						<v-form ref="form" v-model="validFileUpload" >
							<v-row  style="margin: 0" justify="end">
								<v-col >
									<v-file-input
										v-model="attachment1"
										outlined
										label="File upload"
										:rules="[v => !!v || 'File Upload is required']"
									></v-file-input>
								</v-col>
							</v-row>
							<v-row class="text-right" style="margin: 0" justify="end">
								<v-col cols="12" sm="8">
									<v-btn  :disabled="!validFileUpload" color="primary" type="submit" @click="upload">upload(dialogFileUpload)</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog
				v-model="dialogFileDownload.show"
				no-click-animation
				persistent
				content-class="col-sm-4 col-12 hide-box-shadow"
			>
				<v-card>
					<v-card-title class="headline">
						<h3>Confirm File Download</h3>
						<v-spacer></v-spacer>
						<v-btn
							icon
							@click="closeDialogFileDownload"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text class="text-center" style="max-height: 76vh !important; overflow-y: auto;">
						<v-row
							v-if="dialogFileDownload.link != null && dialogFileDownload.link.toLowerCase().match('^.*\.(jpg|jpeg|png|mp4|pdf)$')"
							style="max-height:720px;">
							<v-col style="height:320px; width:100%; display: block; margin-left:15%; margin-right:15%">
								<iframe style="height:100%; width:100%;"
									frameborder="0"
									scrolling="0"
									allowtransparency = "1"
									:src="dialogFileDownload.link">
								</iframe>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-btn
								@click="closeDialogFileDownload"
								>Cancel</v-btn>

								<v-btn
								style="margin-left:12px"
								class="green darken-1"
								dark
								@click="executeDownloadDialog"
								>Download</v-btn>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-dialog>
			<v-dialog
				v-model="dialogAestheticRecordBook.show"
				no-click-animation
				persistent
				max-width="960px"
				scrollable
			>
				<v-card style="overflow: auto;">
					<v-card-title class="headline">
						<v-spacer></v-spacer>
						<v-btn
							icon
							@click="dialogAestheticRecordBook.show = false"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<div id="iframe-container" style="height: 720px;">
						<iframe
							:class="isShow ? 'd-none' : ''"
							:style="{
								zIndex: 1,
								width: '100%',
								height: '700px',
								position: 'absolute'
							}"
							frameborder="0"
							allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture;camera;microphone"
							scrolling="0"
							:src="dialogAestheticRecordBook.value"
							allowfullscreen
						></iframe>
					</div>
				</v-card>
			</v-dialog>
			<v-dialog
				v-model="dialogAestheticRecordMeeting.show"
				no-click-animation
				persistent
				style="overflow: hidden"
				fullscreen
			>
				<v-card>
					<v-card-title class="headline">
						<v-spacer></v-spacer>
						<v-btn
							icon
							@click="dialogAestheticRecordMeeting.show = false"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card
						class="d-none"
						:style="{
							zIndex: 1,
							width: '100%',
							height: '93.5vh',
							position: 'absolute',
						}">
					</v-card>
					<iframe
						:class="isShow ? 'd-none' : ''"
						:style="{
							zIndex: 1,
							width: '100%',
							height: '93.5vh',
							position: 'absolute',
						}"
						frameborder="0"
						allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture; microphone; camera;"
						scrolling="0"
						:src="dialogAestheticRecordMeeting.value"
						allowfullscreen
					></iframe>
				</v-card>
			</v-dialog>
		</v-main>
		<v-overlay style="z-index: 999;" :value="$root.loader.value" opacity="0">
			<img :src="baseLocation + '/resource/image/loader.svg'" class="loader" />
		</v-overlay>
		<div style="position: fixed; bottom: 16px; right: 16px; z-index: 999; max-height: 100vh; overflow-y: auto; overflow-x: hidden;">
			<v-alert v-model="$store.state.webSocketNotification.show"  color="primary" colored-border elevation="2" border="left" max-width="300" icon="mdi-information" dismissible transition="slide-x-reverse-transition">
					<p>{{ $store.state.webSocketNotification.message }}</p>
					<p><a @click="goToRoom($store.state.webSocketNotification.link)" style="text-decoration: underline;">Click Here</a> to return to the meeting room</p>
			</v-alert>
		</div>
		<div v-append="beacon"></div>
	</v-app>
</template>

<style>
#room > .v-main__wrap {
	overflow-x: auto;
}

/* Image Slider */
.custom-slider > .v-window__container > .text-center > .v-image > .v-image__image--cover {
    background-size: contain !important;
}
</style>

<style scoped>
.v-main {
	background-color: black !important;
}
#room-view.v-card__text {
	width: 0px;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
.room-link {
	cursor: pointer;
	position: absolute;
}
.scrollable {
	overflow-y: auto;
	overflow-x: hidden;
	height: 300px;
}
#iframe-container {
	position: relative;
	width: 100%;
	height: 0;
	padding-bottom: 56.25%;
}
#iframe {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}
#v-card-title-zoom-embed {
    padding: 0px;
}

/* Let's get this party started */
::-webkit-scrollbar {
	height: 7px;
	width: 7px;
	background: rgba(65, 109, 116, 1);
}

/* Track */
::-webkit-scrollbar-track {
	-webkit-border-radius: 10px;
	border-radius: 10px;
	background: rgba(0, 0, 0, 0.7);
}

/* Handle */
::-webkit-scrollbar-thumb {
	-webkit-border-radius: 10px;
	border-radius: 10px;
	background: rgba(65, 109, 116, 1);
}
</style>

<script>
/* eslint-disable no-unused-vars */
import axios from "axios";
import { VueIdentifyNetwork } from 'vue-identify-network';

export default {
	props: ["tenantSlug", "experienceSlug"],
	components: {
		VueIdentifyNetwork
	},
	data() {
		return {
			drawer: false,
			entity: { dataMap: {}, transitMap: {} },
			entityList: [],
			boothList: [],
			boothLogo: null,
			index: -1,
			intervalRotatingLogo: null,
			isShow: false,
			dialog: { show: false, title: null, content: null },
			dialogZoom: { show: false, value: "" , presentationId: null},
			dialogTeams: { show: false, value: "", presentationId: null},
			dialogAestheticRecordMeeting: { show: false, value: null },
			dialogAestheticRecordBook: { show: false, value: "" },
			productDialog: { show: false, content: null },
			baseLocation: axios.defaults.baseURL,
			linkTypeDialog: { show: false, content: null },
			dialogProtectRoom: false,
			presentationDialog: { show: false, content: null },
			dialogBio: null,
			dialogVideo: false,
			dialogVideoWithEmbedHtml: false,
			dialogIframe: false,
			videoUrl: null,
			videoIframe: null,
			timeout: null,
			selectedPresenterBio: null,
			selectedPresenterName: null,
			presentationScheduleList: null,
			typeOnDemandVideo: "On-Demand Video",
			typePreRecordedVideo: "Pre-recorded Video",
			typeZoomWebinar: "Zoom Webinar",
			typeZoomMeeting: "Zoom Meeting",
			typeTeamsMeeting: "Teams Meeting",
			typeVimeoLive: "Vimeo Live",
			clinicBookDialog: { show: false, bookingType: 'Send_Email', recipientEmail: null , title: "", name:"Submit"},
			clinicConsultationDialog: { show: false },
			clinicBookResponse: "",
			isSubmitted: false,
			password: "",
			consulEmail: "",
			passwordFieldType: "password",
			clinic_input_name: "",
			clinic_input_email: "",
			clinic_input_phone: "",
			clinic_input_req: "",
			passwordProtect: null,
			validPasswordProtectRoom: true,
			passwordProtectRoomFieldType: "password",
			dialogInfo: false,
			dialogImageSlider: { show: false, images: [] },
			dialogCarousel: { show: false, images: [] },
			dialogFileUpload: { show: false},
			dialogFileDownload: { show: false, link: null, fileName: null },
			validFileUpload: true,
			attachment1: null,
			experience: { dataMap: {} },
			zoomFullName: "",
			zoomEmail: "",
			zoomFormValid: true,
			isShowZoomIframe: false,
			isShowZoomEmbed: true,
			zoomFullNameRules: [
				(v) => !!v || 'Name is required',
				(v) => v.length <= 100 || 'Name must be less than 100 characters'
			],
			zoomEmailRules: [
				(v) => !!v || 'E-mail is required',
				//eslint-disable-next-line
				(v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
			],
			beacon: this.$root.initLiveSupport(),
			layerMode: false,
			vuniteToken: null,
			aestheticRecordAppointment: null,
			zoomLoading: false,
			aestheticToken: null,
			footerMarginTop: '0px',
			footerWidth: 'none',
			embedHtmlBeside: { status: "None", left: "", right: "" },
			embedHtmlBelow: "",
			heightEmbedHtmlBeside: null,
			heightEmbedHtmlBelow: null,
			smLeft: 0,
			smCenter: 12,
			smRight: 0,
			connectionSpeed: 0,
			btnSkipLeft: "calc(100vw - 100px)",
			tmpSlug: "",
			loadType: 'fast',
			isTheFirstLoad: true,
			transitionYoutubeParams: { autoplay: 1, showinfo: 0, controls: 0, mute: 1},
			backgroundYoutubeParams: { autoplay: 1, showinfo: 0, controls: 0, mute: 1, loop: 1, playlist: ''},
			backgroundVimeoParams: {autoplay: true, muted: true, title: false, byline: false, portrait:false, controls: false, loop: true},
			transitionVimeoParams: {autoplay: true, muted: true, title: false, byline: false, portrait:false, controls: false},
			videoTransition: "",
			transitionThumbnail: "",
			showBtnTransition: false,
		};
	},
	computed: {
		structureSlug() {
			return this.$route.params.structureSlug;
		},
		crumbs() {
			let query = this.$route.query;

			let link = '/' + this.tenantSlug + '/' + this.experienceSlug;
			if(query.vuniteToken){
				link += "?vuniteToken=" + query.vuniteToken;
			} else if (query.token){
				link += "?token=" + query.token;
			}


			const breadCrumbs = [ { href: link, text: this.entity.transitMap.experienceName } ];
			breadCrumbs.push({ href: null, text: this.entity.name });
			return breadCrumbs;
		},
	},
	watch: {
		structureSlug: function () {
			this.isShow = false;
			this.presentationDialog.show = false;
			this.findStructure();
		},
		"$store.state.isFitToWidth": function() {
			this.calcScale();
		}
	},
	beforeRouteLeave: function(to, from, next) {
		this.isShowZoomEmbed = true;
		next();
	},
	mounted: function () {
		this.initAestheticRecord(this.$route.query);

		this.setExperience();
		this.findStructure();
		this.calcScale();
		window.onresize = () => {
			this.calcScale();
		};
		if (this.$root.showLiveSupport) {
			this.$root.setCurrentUrlLiveSupport(this.$router.currentRoute.path);
		}

		// setTimeout(() => {
		// 	this.calcScale();
		// }, 15000);
	},
	methods: {
		switchVisibility() {
			this.passwordFieldType =
				this.passwordFieldType === "password" ? "text" : "password";
		},
		findStructure() {
			axios
				.post("/system/public/room/slug", {
					tenantSlug: this.tenantSlug,
					experienceSlug: this.experienceSlug,
					slug: this.structureSlug,
				})
				.then((response) => {
					this.entity.transitMap = response.data.transitMap;
					if (
						this.entity.transitMap &&
						(this.entity.transitMap.isNotReady ||
							this.entity.transitMap.isExpired)
					) {
						this.dialogInfo = true;
					} else {
						this.entity = response.data;

						for (let item of this.entity.linkToDataList) {
							if (item.type === 'Button') {
								if(isNaN(item.borderRadius)) {
									item.borderRadius = item.borderRadius === "rounded" ? "28px" : "0px";
								}  else {
									item.borderRadius = item.borderRadius + 'px';
								}
								if (!isNaN(item.borderWidth)) {
									item.borderWidth = item.borderWidth + 'px';
								}
							}
						}

						// Check if large asset is exist and use it
						let vm = this
						if(!this.$root.isVideo(this.entity.background)){
							this.$root.isImageExist(this.$root.largeAsset(this.entity.background), function(status) {
							if (status) {
								vm.entity.background = vm.$root.largeAsset(vm.entity.background);
							}
							});
						}

						if (this.entity.mainStructure) {
							if (this.connectionSpeed < 1) {
								this.$store.commit('setShowVideoTransition', false);
							} else {
								this.$store.commit('setShowVideoTransition', true);
							}
						}

						if (!this.entity.dataMap.introTransition) {
							this.entity.dataMap.introTransition = {
								autoplay: true,
								sound: false
							}
						}

						if (this.$store.state.showVideoTransition) {
							if (this.$root.isVideo(this.entity.introTransition)) {
								this.tmpSlug = ""
								this.isShow = true;
								let vm = this;
								var video = document.getElementById("videoTransition");
								video.src = this.entity.introTransition;
								video.addEventListener('loadeddata', () => {
									if(video.readyState === 4) {
										this.calcScale();
										document.getElementsByClassName("v-main__wrap")[0].scrollLeft = (video.getBoundingClientRect().width-window.innerWidth)/2;
									}
								});

								if (this.entity.dataMap.introTransition.autoplay) {
									video.play();
								} else {
									this.showBtnTransition = true;
								}
								video.muted = !this.entity.dataMap.introTransition.sound;

								video.addEventListener('playing', () => {
									this.showBtnTransition = false;
								});
								video.addEventListener('pause', () => {
									this.showBtnTransition = true;
								});

								video.onended = function () {
									vm.isShow = false;
									vm.calcScale();
								};
							} else if (this.$root.isYoutubeUrl(this.entity.introTransition)) {
								this.tmpSlug = ""
								this.isShow = true;
								this.videoTransition = this.$root.getYoutubeId(this.entity.introTransition, null);
								this.transitionThumbnail = "https://img.youtube.com/vi/" + this.videoTransition + "/maxresdefault.jpg";

								this.transitionYoutubeParams.mute = !this.entity.dataMap.introTransition.sound ? 1 : 0;
								this.transitionYoutubeParams.autoplay = this.entity.dataMap.introTransition.autoplay ? 1 : 0;
								if (!this.entity.dataMap.introTransition.autoplay || (this.entity.dataMap.introTransition.autoplay && this.entity.dataMap.introTransition.sound)) {
									this.showBtnTransition = true;
								}

								this.$nextTick(() => {
									if (this.$vuetify.breakpoint.mobile && this.entity.dataMap.introTransition.autoplay){
										this.$refs.backgroundTransition.player.playVideo();
									}
								});
							} else if (this.$root.isVimeoUrl(this.entity.introTransition)) {
								this.tmpSlug = ""
								this.isShow = true;
								this.videoTransition = this.entity.introTransition;

								axios
									.get("/system/public/vimeo/thumbnail?vimeoUrl=" + this.videoTransition)
									.then(async (response) => {
										if (response.data) {
											this.transitionThumbnail = response.data;
										}
									})
								this.transitionVimeoParams.muted = !this.entity.dataMap.introTransition.sound;
								this.transitionVimeoParams.autoplay = this.entity.dataMap.introTransition.autoplay;
								if (!this.entity.dataMap.introTransition.autoplay) {
									this.showBtnTransition = true;
								}
							}
						}

						this.$nextTick(() => {
							if (this.$root.isVideo(this.entity.background)) {
								var videoBackground = document.getElementById("video");
								videoBackground.load();
								let vm = this;
								videoBackground.addEventListener('loadeddata', () => {
									if(videoBackground.readyState === 4) {
										vm.calcScale();
									}
								});
							}
						});

						if (this.entity.dataMap.isPasswordProtectRoom) {
							this.dialogProtectRoom = true;
							this.passwordProtect = null;
						}

						this.checkAestheticRecordMeetings();
					}
				})
				.catch(() => {});
		},
		checkAestheticRecordMeetings() {
			if(this.entity.linkToDataList.find((obj) => obj.type === "Attend_Aesthetic_Record_Meeting" && this.vuniteToken != null) ){
				axios
					.post("/system/public/aesthetic/record/vuniteToken", {
						vuniteToken: this.vuniteToken,
						structureId: this.entity.id
					})
					.then((response) => {
						this.aestheticRecordAppointment = response.data;
						if(this.aestheticRecordAppointment != null && this.aestheticRecordAppointment.meetingUrl != null){
							this.dialogAestheticRecordMeeting.value = this.aestheticRecordAppointment.meetingUrl;
						}
					});
			} else if(this.entity.linkToDataList.find((obj) => obj.type === "Show_Aesthetic_Record_Meeting" && this.aestheticToken != null)){
				axios
					.post("/system/public/aesthetic/record/aestheticToken", {
						aestheticToken: this.aestheticToken,
						structureId: this.entity.id
					})
					.then((response) => {
						this.aestheticRecordAppointment = response.data;
						if(this.aestheticRecordAppointment != null && this.aestheticRecordAppointment.meetingUrl != null){
							this.dialogAestheticRecordMeeting.value = this.aestheticRecordAppointment.meetingUrl;
						}
					});
			}
		},
		showAestheticRecordBookDialog(item){
			axios
				.post("/system/public/aesthetic/record/token/generate", {structureId: item.target}).then(
					(response) => {
						this.dialogAestheticRecordBook.show = true;
						this.dialogAestheticRecordBook.value = item.value + "?vuniteToken=" + response.data;
					}
				);
		},
		prefetchStructureList(experienceId) {
			axios
				.get("/system/structure/list?experienceId=" + experienceId)
				.then((response) => {
					let list = [];
					let videoList = [];
					for (let entry of response.data) {
						if (entry && entry.background) {
							if (this.$root.isImage(entry.background)) {
								list.push(entry);
							} else if (this.$root.isVideo(entry.background)) {
								if (
									!(
										entry.dataMap &&
										entry.dataMap.prefetch == "false"
									)
								) {
									videoList.push(entry);
								}
							}
						}
					}
					this.entityList = list.concat(videoList);
				})
				.catch(() => {});
		},
		linkTo(entity) {
			if (entity.type === "Structure") {
				this.sendToGA(entity);
				axios
					.post("/system/public/room", {
						tenantSlug: this.tenantSlug,
						experienceSlug: this.experienceSlug,
						id: entity.value,
					})
					.then((response) => {
						let url = this.$store.state.domainThatUseAliases.includes(window.location.hostname.toLowerCase()) ? //
							('/' + response.data.slug) : //
							( "/" + this.tenantSlug + "/" + this.experienceSlug + "/room/" + response.data.slug + this.appendAestheticRecordQuery());

						this.showBtnTransition = false;
						this.transitionThumbnail = "";
						if (!this.entity.dataMap.outroTransition) {
							this.entity.dataMap.outroTransition = {
								autoplay: true,
								sound: false
							}
						}

						if (this.$store.state.showVideoTransition && this.$root.isVideo(this.entity.outroTransition)) {
							this.tmpSlug = response.data.slug;
							this.isShow = true;
							var video = document.getElementById("videoTransition");
							video.src = this.entity.outroTransition;
							video.addEventListener('loadeddata', () => {
								if(video.readyState === 4) {
									document.getElementsByClassName("v-main__wrap")[0].scrollLeft = (video.getBoundingClientRect().width-window.innerWidth)/2;
								}
							});
							if (this.entity.dataMap.outroTransition.autoplay) {
								video.play();
							} else {
								this.showBtnTransition = true;
							}
							video.muted = !this.entity.dataMap.outroTransition.sound;

							video.addEventListener('playing', () => {
								this.showBtnTransition = false;
							});
							video.addEventListener('pause', () => {
								this.showBtnTransition = true;
							});

							let vm = this;
							video.onended = function () {
								vm.entity.background = null;
								vm.entity.introTransition = null;
								vm.entity.outroTransition = null;
								vm.entity.linkToDataList = [];
								vm.$router.push(url);
							};
						} else if (this.$store.state.showVideoTransition && this.$root.isYoutubeUrl(this.entity.outroTransition)) {
							this.tmpSlug = response.data.slug;
							this.isShow = true;
							this.videoTransition = this.$root.getYoutubeId(this.entity.outroTransition, null);
							this.transitionThumbnail = "https://img.youtube.com/vi/" + this.videoTransition + "/maxresdefault.jpg";

							this.transitionYoutubeParams.mute = !this.entity.dataMap.outroTransition.sound ? 1 : 0;
							this.transitionYoutubeParams.autoplay = this.entity.dataMap.outroTransition.autoplay ? 1 : 0;
							if (!this.entity.dataMap.outroTransition.autoplay && !this.showBtnTransition) {
								this.showBtnTransition = true;
							}

							this.$nextTick(() => {
								if (this.$vuetify.breakpoint.mobile && this.entity.dataMap.outroTransition.autoplay){
									this.$refs.backgroundTransition.player.playVideo();
								}
							});
						} else if (this.$store.state.showVideoTransition && this.$root.isVimeoUrl(this.entity.outroTransition)) {
							this.tmpSlug = response.data.slug;
							this.isShow = true;
							this.videoTransition = this.entity.outroTransition;

							this.transitionVimeoParams.muted = !this.entity.dataMap.outroTransition.sound;
							this.transitionVimeoParams.autoplay = this.entity.dataMap.outroTransition.autoplay;
							if (!this.entity.dataMap.outroTransition.autoplay) {
								this.showBtnTransition = true;
							} else {
								this.$refs.backgroundTransitionVimeo.play();
							}
						} else {
							this.$router.push(url);
						}

						this.calcScale();
					});
			} else if (entity.type === "Booth") {
				this.sendToGA(entity);
				this.$router.push(
					"/" +
						this.tenantSlug +
						"/" +
						this.experienceSlug +
						"/booth/" +
						entity.value
				);
			} else if (entity.type === "Auditorium") {
				this.sendToGA(entity);
				this.$router.push(
					"/" +
						this.tenantSlug +
						"/" +
						this.experienceSlug +
						"/auditorium/" +
						entity.value
				);
			} else if (entity.type === "Track") {
				this.sendToGA(entity);
				this.$router.push(
					"/" +
						this.tenantSlug +
						"/" +
						this.experienceSlug +
						"/auditorium/" +
						entity.subType +
						"/track/" +
						entity.value
				);
			} else if (["Chat", "Leaderboard"].includes(entity.type)) {
				this.sendToGA(entity);
				this.$router.push(
					"/" +
						this.tenantSlug +
						"/" +
						this.experienceSlug +
						"/" +
						entity.type.toLowerCase()
				);
			} else if (entity.type === "Book_Consultation") {
				this.clinicBookDialog.show = true;
				this.clinicBookDialog.title = entity.title;
				if(entity.name != null){
					this.clinicBookDialog.name = entity.name;
				}
				if(entity.bookingType){
					this.clinicBookDialog.bookingType = entity.bookingType;
					this.clinicBookDialog.recipientEmail = entity.email;
				}
			} else if (entity.type === "Attend_Consultation") {
				this.clinicConsultationDialog.show = true;
			} else if (entity.type === "URL") {
				this.sendToGA(entity);
				if (entity.target === "New Tab") {
					window.open(entity.value, "_blank");
				} else if (entity.target === "Current Tab") {
					window.open(entity.value, "_self");
				} else if (entity.target === "Dialog") {
					this.dialog.show = true;
					this.dialog.title = entity.title;
					this.dialog.content = entity.value;
					this.iframeControl(entity.value);
				}
			} else if (entity.type === "Product") {
				this.productDialog.show = true;
				this.productDialog.content = JSON.parse(entity.value);
			} else if (entity.type === "Dialog") {
				this.sendToGA(entity);
				this.linkTypeDialog.show = true;
				this.linkTypeDialog.content = entity.value;
				this.linkTypeDialog.backgroundColor = entity.backgroundColor;
				this.linkTypeDialog.transparent = entity.backgroundColor == '#FFFFFF00' ? '#FFFFFFFF' : '#00000000';
			} else if (entity.type === "Presentation") {
				this.presentationDialog.show = true;
				this.presentationDialog.content = entity.value;
				axios
					.post("/system/public/presentationschedule/clinic/list", {
						presentationScheduleId: entity.value
							.split(",")
							.map(Number),
						tenantSlug: this.tenantSlug,
						experienceSlug: this.experienceSlug,
					})
					.then((response) => {
						this.presentationScheduleList = response.data;
						this.countDownTimer();
					})
					.catch(() => {});
			} else if (entity.type === "Embed_HTML") {
				if (entity.target === "Dialog") {
					this.sendToGA(entity);
					this.dialog.contentType = entity.type;
					this.dialog.content = entity.valueRender ? entity.valueRender : entity.value;
					this.dialog.title = entity.title;
					this.dialog.show = true;
					this.dialog.backgroundColor = entity.backgroundColor;
					this.dialog.transparent = entity.backgroundColor == '#FFFFFF00' ? '#FFFFFFFF' : '#00000000';

					let embed = document.getElementById('embedHtml');
					if (embed != null) {
						embed.innerHTML = entity.valueRender ? entity.valueRender : entity.value;
					}

					// Scroll to center for smaller screen
					let iframeContainer = this.$refs.embedHtmlContainer;
					this.$nextTick(() => {
						// Child: Div hotspot_embed_html -> Iframe value with defined width
						if(iframeContainer.children[0].children){
							let iframe = iframeContainer.children[0].children[0];
							if (iframe != null) {
								let offset = iframe.clientWidth - iframeContainer.clientWidth;
								if(offset > 0){
									iframeContainer.scrollLeft = offset / 2;
								}
							}
						}
					});
				}
			} else if (entity.type === "Zoom") {
				if (entity.target === "Dialog") {
					this.sendToGA(entity);
					this.dialogZoom.value = entity.value;
					this.dialogZoom.disablePreview = entity.disablePreview;
					this.dialogZoom.show = true;
					this.isShowZoomIframe = false;
				}
			} else if (entity.type === "Teams") {
				if (entity.target === "Dialog") {
					this.sendToGA(entity);
					this.dialogTeams.value = entity.value;
					this.dialogTeams.show = true;
				}
			} else if (entity.type == "Image_Slider") {
				this.dialogImageSlider.show = true;
				this.dialogImageSlider.type = entity.type;
				this.dialogImageSlider.id = entity.id;
				this.dialogImageSlider.label = entity.label;
				this.dialogImageSlider.images = entity.images;
				this.dialogImageSlider.backgroundColor = entity.backgroundColor;
				this.dialogImageSlider.transparent = entity.backgroundColor == '#FFFFFF00' ? '#FFFFFFFF' : '#00000000';
			} else if (entity.type == "File_Upload") {
				this.dialogFileUpload.show = true;
				this.dialogFileUpload.type = entity.type;
				this.dialogFileUpload.id = entity.id;
				this.dialogFileUpload.label = entity.label;
			} else if (entity.type == "Live_Support") {
				this.sendToGA(entity);
				this.$root.dialogLiveSupport(this.experience.dataMap.tenantName, this.experience.name);
			} else if (entity.type == "Book_Aesthetic_Record_Meeting"){
				this.showAestheticRecordBookDialog(entity);
			} else if (entity.type == "Attend_Aesthetic_Record_Meeting" || entity.type == "Show_Aesthetic_Record_Meeting"){
				if(this.dialogAestheticRecordMeeting.value != null){
					this.dialogAestheticRecordMeeting.show = true;
				} else {
					alert("Meeting token required. please access this using invitation from your email");
				}
			}
		},
		iframeControl(value) {
			var iframe = document.getElementById("iframe");
			if (iframe != null) {
				iframe.src = this.$root.asset(value);
			}
			var frame = iframe.cloneNode();
			iframe.parentNode.replaceChild(frame, iframe);

			// handle close embed html type
			if (this.dialog.contentType === 'Embed_HTML') {
				let embed = document.getElementById('embedHtml');
				if (value == "" && embed != null) {
					embed.innerHTML = "";
				}
			}
		},
		presenterName(presenter) {
			var firstName =
				presenter.firstName != null
					? this.$root.textify(presenter.firstName)
					: "";
			var lastName =
				presenter.lastName != null
					? this.$root.textify(presenter.lastName)
					: "";
			var title =
				presenter.title != null
					? this.$root.textify(presenter.title)
					: "";
			return firstName + " " + lastName + " " + title;
		},
		formatTime(seconds) {
			if (seconds > 86400) {
				return "more than a day";
			} else {
				return new Date(seconds * 1000).toISOString().substr(11, 8);
			}
		},
		formatDays(seconds) {
			if(seconds > 86400){
				return Math.floor(seconds / 86400);
			} else {
				return 0;
			}
		},
		formatHours(seconds) {
			if(seconds > 3600){
				return Math.floor(seconds / 3600);
			} else {
				return 0;
			}
		},
		formatMinutes(seconds) {
			if(seconds > 0){
				return new Date(seconds * 1000).getMinutes();
			} else {
				return 0;
			}
		},
		formatSeconds(seconds) {
			if(seconds > 0){
				return new Date(seconds * 1000).getSeconds();
			} else {
				return 0;
			}
		},
		formatTime12Hours(time) {
			time = time
				.toString()
				.match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

			if (time.length > 1) {
				time = time.slice(1);
				time[5] = +time[0] < 12 ? "AM" : "PM";
				time[0] = +time[0] % 12 || 12;
			}

			return time.join("");
		},
		joinZoom() {
			let zoomEntity = {
				experienceId: this.experience.id,
				presentationId: this.dialogZoom.presentationId,
				email: this.zoomEmail,
				name: this.zoomFullName,
				zoomLink: this.dialogZoom.value
			}
			axios.post("/system/public/zoommeetinglog/add", { entity: zoomEntity });

			this.isShowZoomIframe = true;
			this.zoomLoading = true;
		},
		downloadHandout(name) {
			location.href =
				this.baseLocation +
				"/asset/file/" +
				name +
				"?download&time=" +
				new Date();
		},
		clinicSubmitBook(e) {
			if (
				this.clinic_input_name.length > 0 &&
				this.clinic_input_email.length > 0 &&
				this.clinic_input_phone.length > 0 &&
				this.clinic_input_req.length > 0 &&
				/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
					this.clinic_input_email
				)
			) {
				if(this.clinicBookDialog.bookingType && this.clinicBookDialog.bookingType == 'Send_Email'){
					this.sendBooking();
				} else {
					this.createBooking();
				}

			} else {
				e.preventDefault();
			}
		},
		createBooking(){
			axios
				.post("/system/clinic/book/create", {
					name: this.clinic_input_name,
					email: this.clinic_input_email,
					phone: this.clinic_input_phone,
					req: this.clinic_input_req,
					slug: this.experienceSlug,
					bookingSlug: this.structureSlug
				})
				.then((response) => {
					this.isSubmitted = true;
					this.clinic_input_name = "";
					this.clinic_input_email = "";
					this.clinic_input_phone = "";
					this.clinic_input_req = "";
					this.clinicBookResponse = response.data;
				})
				.catch(() => {});
		},
		sendBooking(){
			axios
				.post("/system/clinic/book/send", {
					name: this.clinic_input_name,
					email: this.clinic_input_email,
					phone: this.clinic_input_phone,
					req: this.clinic_input_req,
					slug: this.experienceSlug,
					recipientEmail : this.clinicBookDialog.recipientEmail
				})
				.then((response) => {
					this.isSubmitted = true;
					this.clinic_input_name = "";
					this.clinic_input_email = "";
					this.clinic_input_phone = "";
					this.clinic_input_req = "";
					this.clinicBookResponse = response.data;
				})
				.catch(() => {});
		},
		clinicConsultation() {
			if (
				this.consulEmail.length > 0 &&
				this.password.length > 0 &&
				/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
					this.consulEmail
				)
			) {
				axios
					.post("/system/clinic/consultation", {
						email: this.consulEmail,
						password: this.password,
						slug: this.experienceSlug,
					})
					.then((response) => {
						this.consulEmail = "";
						this.password = "";
						if (response.data != null) {
							this.clinicConsultationDialog.show = false;
							window.open(response.data.zoomLink, "_blank");
						} else {
							alert(
								"Incorrect! Please check your email account and consultation password that has been sent to your email."
							);
						}
					})
					.catch(() => {});
			}
		},
		checkPasswordProtectRoom() {
			axios
				.post("/system/structure/checkpasswordprotectroom", {
					password: this.passwordProtect,
					id: this.entity.id,
				})
				.then((response) => {
					if (response.data) {
						this.dialogProtectRoom = false;
					}
				});
		},
		goBack() {
			this.$router.go(-1);
			this.entity.background = null;
			this.entity.outroTransition = null;
			this.dialogProtectRoom = false;
		},
		formatDate(date) {
			if (date != null) {
				var year = parseInt(date.substring(0, 4));
				var month = parseInt(date.substring(5, 7));
				var day = parseInt(date.substring(8, 10));
				const monthNames = [
					"January",
					"February",
					"March",
					"April",
					"May",
					"June",
					"July",
					"August",
					"September",
					"October",
					"November",
					"December",
				];
				return monthNames[month - 1] + " " + day + ", " + year;
			} else {
				return "";
			}
		},
		countDownTimer() {
			for (let presentation of this.presentationScheduleList) {
				if (presentation.dataMap.toEndTime >= -5) {
					presentation.dataMap.toStartTime -= 1;
					presentation.dataMap.toEndTime -= 1;
					presentation.dataMap.toLiveTime += 1;
					this.$forceUpdate();
				}
			}

			this.timeout = setTimeout(() => {
				clearTimeout(this.timeout);
				this.countDownTimer();
			}, 1000);
		},
		closeNotification() {
			if (this.$store.state.notification.title === "Unauthorized") {
				this.$store.commit("hideNotification");
				this.$router.push(
					"/" + this.tenantSlug + "/" + this.experienceSlug
				);
			} else if (this.$store.state.notification.title === "Forbidden") {
				this.$store.commit("hideNotification");
				this.$router.go(-1);
			} else {
				this.$store.commit("hideNotification");
			}
		},
		navigateTo(menu) {
			this.menuRoot = false;
			if (menu.linkTo) {
				if (menu.linkType === "URL") {
					window.open(menu.linkTo, "_blank");
				} else if (menu.linkType === "Room") {
					let path = this.$store.state.domainThatUseAliases.includes(window.location.hostname.toLowerCase()) ? ('/' + menu.linkTo) : (
						"/" +
						this.tenantSlug +
						"/" +
						this.experienceSlug +
						"/room/" +
						menu.linkTo + this.appendAestheticRecordQuery());

					if (this.$route.path !== path) {
						this.$router.push(path);
					}
				}
			}
		},
		upload(entity) {
			this.setExperience();
			let formData = new FormData();
			formData.append("experienceId", this.experience.id);
			formData.append("tenantId", this.experience.tenantId);
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}

			axios
				.post("/system/public/structure/linkto/fileUpload", formData)
				.then(response => {
					if (response.data) {
						this.dialogFileUpload = false;
						this.attachment1 = "";
						this.sendToGA(entity);
					}
				})
				.catch(() => {});
		},
		setExperience() {
			axios
				.post("/system/public/experience", {
					tenantSlug: this.tenantSlug,
					experienceSlug: this.experienceSlug
				})
				.then(response => {
					this.experience = response.data;
					this.$store.commit("setIsPoweredBy", this.experience.transitMap.poweredBy);
                    this.$store.commit("setFooterText", this.experience.transitMap.footerText);
					this.layerMode = this.experience.layerMode;
					if(this.experience.status == false){
						this.dialogInfo = true;
					}

					if(this.experience.menuDataList && this.experience.menuDataList.length > 0){
						// Preset hamburger opened
						for (let menu of this.experience.menuDataList){
							menu.toggleOpen = true;
							if(menu.childList && menu.childList.length > 0){
								for (let child of menu.toggleOpen){
									child.toggleOpen = true;
								}
							}
						}
					}
				})
				.catch(() => {});
		},
		calcScale() {
			var custom = document.getElementById("custom");
			var room = document.getElementById("room-view");
			var scale = 1;
			if (document.body.clientWidth >= 960 && !this.$vuetify.breakpoint.mobile) {
				this.btnSkipLeft = "calc(100vw - 100px)";
				if (room != null) {
					let height = window.innerHeight;
					if ((this.experience.dataMap.fitToHeight && this.$store.state.isFitToWidth === null) || this.$store.state.isFitToWidth) {
						this.$nextTick(function() {
							scale = window.innerHeight / (1080 * 0.5);
							if (!this.isShow) {
								if (this.$refs.background && this.$refs.background.clientHeight > (1080 * 0.5)) {
									scale = height/this.$refs.background.clientHeight;
								}
							} else {
								if (this.$refs.backgroundTransition && this.$refs.backgroundTransition.clientHeight > (1080 * 0.5)) {
									scale = height/this.$refs.backgroundTransition.clientHeight;
								}
							}
							custom.style.position = "relative";
							custom.style.paddingLeft = (document.body.clientWidth - Math.abs((960 - (1 - scale) * (1920 * 0.5))))/2 + "px";
							room.style.transform = "scale(" + scale + ")";
							room.style.position = "absolute";

						});
					} else {
						scale = document.body.clientWidth / (1920 * 0.5);
						room.style.transform = "scale(" + scale + ")";
						custom.style.paddingLeft = "0px";
					}
					if (!this.isShow) {
						this.footerMarginTop = height + "px";
					} else {
						this.footerMarginTop = "5px";
					}
				}
			} else {
				custom.style.paddingLeft = "0";
				this.btnSkipLeft = "calc(100vw - 80px)";
				this.$nextTick(function() {
					if (((this.experience.dataMap.fitToHeight && this.$store.state.isFitToWidth === null) || this.$store.state.isFitToWidth) && window.innerHeight > window.innerWidth) {
						scale = document.body.clientWidth / (1920 * 0.5)
					} else {
						scale = window.innerHeight / (1080 * 0.5);
					}
					let height = window.innerHeight;
					if (!this.isShow) {
						if (this.$refs.background && this.$refs.background.clientHeight > (1080 * 0.5) && window.innerHeight < window.innerWidth) {
							scale = height/this.$refs.background.clientHeight;
						}
						if (this.$refs.background && document.body.clientWidth > (this.$refs.background.clientWidth * scale)) {
							custom.style.paddingLeft = (document.body.clientWidth - Math.abs((960 - (1 - scale) * (1920 * 0.5))))/2 + "px";
						}
					} else {
						if (this.$refs.backgroundTransition && this.$refs.backgroundTransition.clientHeight > (1080 * 0.5) && window.innerHeight < window.innerWidth) {
							scale = height/this.$refs.backgroundTransition.clientHeight;
						}
						if (this.$refs.backgroundTransition && document.body.clientWidth > (this.$refs.backgroundTransition.clientWidth * scale)) {
							custom.style.paddingLeft = (document.body.clientWidth - Math.abs((960 - (1 - scale) * (1920 * 0.5))))/2 + "px";
						}
					}
					room.style.transform = "scale(" + scale + ")";
				});
				document.getElementsByClassName("v-main")[0].id = "room";

				if (!this.$store.state.isFitToWidth) {
					if (this.$refs.background) {
						this.footerWidth = (this.$refs.background.clientWidth * scale) + 'px';
					}
				} else {
					this.footerWidth = window.innerWidth + 'px';
				}
			}

			if (this.experience.dataMap.fitToHeight && this.$store.state.isFitToWidth === null) {
				this.$store.commit('setFitToWidth', this.experience.dataMap.fitToHeight);
				if (this.isTheFirstLoad) {
					this.experience.dataMap.fitToHeight = false;
					this.isTheFirstLoad = false;
				}
			}

			this.$nextTick(() => {
				if (this.$refs.background) {
					if (!this.isShow) {
						if (this.$vuetify.breakpoint.mobile){
							if (!this.$store.state.isFitToWidth) {
								this.footerWidth = (this.$refs.background.clientWidth*scale) + 'px';
							} else {
								this.footerWidth = window.innerWidth + 'px';
							}
						}
						document.getElementsByClassName("v-main__wrap")[0].scrollLeft = ((this.$refs.background.clientWidth*scale)-window.innerWidth)/2;
					} else {
						document.getElementsByClassName("v-main__wrap")[0].scrollLeft = ((this.$refs.backgroundTransition.clientWidth*scale)-window.innerWidth)/2;
					}
					let height = this.$refs.roomView.clientHeight * scale;
					this.footerMarginTop = height + "px";
				}
			});
		},
		fileDownload(linkTo){
			this.sendToGA(linkTo);
			let url = this.$root.asset(linkTo.value);

			if (linkTo.subType == "Dialog"){
				this.dialogFileDownload.fileName = this.$root.getFileNameFromUrl(url);
				this.dialogFileDownload.link = url;
				this.dialogFileDownload.show = true;
			} else {
				this.$root.executeFileDownload(linkTo);
			}
		},
		executeDownloadDialog(){
			location.href = this.dialogFileDownload.link + "?download";
			this.closeDialogFileDownload();
		},
		closeDialogFileDownload(){
			this.dialogFileDownload.show = false;
			this.dialogFileDownload.fileName = null;
			this.dialogFileDownload.link = null;
		},
		goToRoom(link){
			this.$router.push(link).catch(()=>{});
		},
		zoomLoad() {
			this.zoomLoading = false;
		},
		initAestheticRecord(query){
			if(query.vuniteToken){
				this.vuniteToken = query.vuniteToken;
				this.$root.connectToWebSocket("/system/public/channel/notification?token=" + this.vuniteToken);
			} else if(query.token){
				this.aestheticToken = query.token;
				this.$root.connectToWebSocket("/system/public/channel/notification?token=" + this.aestheticToken);
			}
		},
		appendAestheticRecordQuery(){
			if(this.vuniteToken){
				return "?vuniteToken=" + this.vuniteToken;
			} else if (this.aestheticToken){
				return "?token=" + this.aestheticToken;
			} else {
				return "";
			}
		},
		closeDialog() {
			this.dialog = { show: false, title: null, content: null };
		},
		showZoomPresentation(presentation) {
			this.dialogZoom.value = presentation.participantUrl;
			this.dialogZoom.presentationId = presentation.id;
			this.embedHtmlBeside = presentation.embedHtmlBesideMap;
			this.embedHtmlBelow = presentation.embedHtmlBelow;
			this.heightEmbedHtmlBeside = presentation.dataMap.heightEmbedHtmlBeside;
			this.heightEmbedHtmlBelow = presentation.dataMap.heightEmbedHtmlBelow;
			this.setSm();
			this.dialogZoom.disablePreview = presentation.dataMap.disablePreview;
			this.dialogZoom.show = true;
			this.isShowZoomIframe = false;

			this.$nextTick(() => {
				if (!this.heightEmbedHtmlBeside) {
					this.heightEmbedHtmlBeside = '93.5vh';
				} else {
					this.heightEmbedHtmlBeside = this.heightEmbedHtmlBeside + 'px';
				}

				if (!this.heightEmbedHtmlBelow) {
					this.heightEmbedHtmlBelow = '93.5vh';
				} else {
					this.heightEmbedHtmlBelow = this.heightEmbedHtmlBelow + 'px'
				}
			});
		},
		showTeamsPresentation(presentation) {
			this.dialogTeams.value = presentation.participantUrl;
			this.dialogTeams.presentationId = presentation.id;
			this.embedHtmlBeside = presentation.embedHtmlBesideMap;
			this.embedHtmlBelow = presentation.embedHtmlBelow;
			this.heightEmbedHtmlBeside = presentation.dataMap.heightEmbedHtmlBeside;
			this.heightEmbedHtmlBelow = presentation.dataMap.heightEmbedHtmlBelow;
			this.setSm();
			this.dialogTeams.show = true;

			this.$nextTick(() => {
				if (!this.heightEmbedHtmlBeside) {
					this.heightEmbedHtmlBeside = '93.5vh';
				} else {
					this.heightEmbedHtmlBeside = this.heightEmbedHtmlBeside + 'px';
				}

				if (!this.heightEmbedHtmlBelow) {
					this.heightEmbedHtmlBelow = '93.5vh';
				} else {
					this.heightEmbedHtmlBelow = this.heightEmbedHtmlBelow + 'px'
				}
			});
		},
		closeZoomDialog(){
			this.dialogZoom = { show: false, value: "" , presentationId: null}
		},
		setSm() {
			if (this.embedHtmlBeside.status == 'Left') {
				this.smLeft = 3;
				this.smCenter = 9;
				this.smRight = 0;
			} else if (this.embedHtmlBeside.status == 'Right') {
				this.smLeft = 0;
				this.smCenter = 9;
				this.smRight = 3;
			} else {
				this.smLeft = 0;
				this.smCenter = 12;
				this.smRight = 0;
			}
		},
		enterPresentation(item) {
			this.videoUrl = item.videoUrl;
			if ((item.embedHtmlBesideMap && item.embedHtmlBesideMap.status !== 'None' && item.embedHtmlBesideMap.value) || item.embedHtmlBelow) {
				this.embedHtmlBeside = item.embedHtmlBesideMap;
				this.embedHtmlBelow = item.embedHtmlBelow;
				this.heightEmbedHtmlBeside = item.dataMap.heightEmbedHtmlBeside;
				this.heightEmbedHtmlBelow = item.dataMap.heightEmbedHtmlBelow;
				this.setSm();
				this.dialogVideoWithEmbedHtml = true;

				this.$nextTick(() => {
					if (!this.heightEmbedHtmlBeside) {
						if (this.$refs.contentPresentation.clientHeight == 0) {
							this.dialogVideoWithEmbedHtml = false;
							// call one more time, to get the height of contentPresentation
							this.enterPresentation(item);
						} else {
							this.heightEmbedHtmlBeside =  this.$refs.contentPresentation.clientHeight;
						}
					}
					if (!this.heightEmbedHtmlBelow) {
						if (this.$refs.contentPresentation.clientHeight == 0) {
							this.dialogVideoWithEmbedHtml = false;
							// call one more time, to get the height of contentPresentation
							this.enterPresentation(item);
						} else {
							this.heightEmbedHtmlBelow = this.$refs.contentPresentation.clientHeight;
						}
					}
				});
			} else {
				this.dialogVideo = true;
			}
		},
		handleNetworkSpeed(speed) {
			console.log('downlink: ', speed);
			this.connectionSpeed = speed;
			let isConnectionKnown = this.connectionSpeed == 'Unknown' ? false : true;

			if(isConnectionKnown == false) {
				this.loadType = 'unknown';
			}
		},
		setShowVideoTransition() {
			this.$store.commit('setShowVideoTransition', this.$store.state.showVideoTransition);
		},
		stopVideoTransition(url) {
			let type = this.$root.getVideoTypeByUrl(url);
			if (type == 'mp4') {
				var video = document.getElementById("videoTransition");
				video.pause();
				video.currentTime = 0;
			} else if (type == 'youtube') {
				this.$refs.backgroundTransition.player.pauseVideo();
				this.$refs.backgroundTransition.player.currentTime = 0;
			} else if (type == 'vimeo') {
				this.$refs.backgroundTransitionVimeo.pause();
				this.$refs.backgroundTransitionVimeo.currentTime = 0;
			}
			this.transitionThumbnail = "";

			this.isShow = false;
			if (this.tmpSlug) {
				this.entity.background = null;
				this.entity.introTransition = null;
				this.entity.outroTransition = null;
				this.entity.linkToDataList = [];
				if (this.$store.state.domainThatUseAliases.includes(window.location.hostname.toLowerCase())) {
					this.$router.push("/" + this.tmpSlug);
				} else {
					this.$router.push(
						"/" +
							this.tenantSlug +
							"/" +
							this.experienceSlug +
							"/room/" +
							this.tmpSlug
					);
				}

			} else {
				this.calcScale();
			}

			this.$nextTick(() => {
				if (this.$vuetify.breakpoint.mobile){
					if (this.$refs.background) {
						if (this.$refs.background.player) {
							this.$refs.background.player.playVideo();
						}
					}
				}
			});
		},
		transitionEnds(isYoutubeUrl) {
			this.isShow = false;
			if (!isYoutubeUrl) {
				this.$refs.backgroundTransitionVimeo.pause();
				this.$refs.backgroundTransitionVimeo.currentTime = 0;
			}

			if (this.$root.isYoutubeUrl(this.entity.background)) {
				this.$nextTick(() => {
					if (this.$vuetify.breakpoint.mobile){
						this.$refs.background.player.playVideo();
					}
				});
			}

			if (this.tmpSlug) {
				this.entity.background = null;
				this.entity.introTransition = null;
				this.entity.outroTransition = null;
				this.entity.linkToDataList = [];

				if (this.$store.state.domainThatUseAliases.includes(window.location.hostname.toLowerCase())) {
					this.$router.push("/" + this.tmpSlug);
				} else {
					this.$router.push(
						"/" +
							this.tenantSlug +
							"/" +
							this.experienceSlug +
							"/room/" +
							this.tmpSlug
					);
				}
			}
		},
		setFitToScreen() {
			this.$store.commit('setFitToWidth', this.$store.state.isFitToWidth);
		},
		sendToGA(entity) {
			this.$gtag.set({dimension1: entity.id});
			this.$gtag.set({dimension2: entity.label ? entity.label : "-"});
			this.$gtag.set({dimension3: entity.type});
			this.$gtag.set({dimension4: "-"});
			this.$gtag.set({dimension5: this.experience.name});
			this.$gtag.set({dimension6: this.structureSlug});
			this.$gtag.set({dimension7: this.experience.id});
			this.$gtag.set({dimension8: this.experience.name});

			this.$gtag.event('linkTo_event', {
				event_category: 'LinkTo',
				event_label: window.location,
				LinkToId: entity.id,
				LinkToLabel: entity.label ? entity.label : "-",
				LinkToType: entity.type,
				UserId: "-",
				Name: this.experience.name,
				RoomName: this.structureSlug,
				ExperienceId: this.experience.id,
				ExperienceName: this.experience.name,
				room: this.entity.name ?? ''
			});
		},
		playVideoTransition(url) {
			let type = this.$root.getVideoTypeByUrl(url);
			if (type == 'mp4') {
				var video = document.getElementById("videoTransition");
				video.play();
			} else if (type == 'youtube') {
				this.$refs.backgroundTransition.player.playVideo();
			} else if (type == 'vimeo') {
				this.$refs.backgroundTransitionVimeo.play();
			}
		},
		setShowBtnTransition(status) {
			if (status && this.tmpSlug) {
				if (this.entity.dataMap.outroTransition.autoplay) {
					this.showBtnTransition = false;
				}
			} else {
				this.showBtnTransition = status;
			}
		},
		previousPage() {
			window.history.go(-1);
		}
	},
};
</script>